import { Component, EventEmitter, HostListener, Input, OnInit, AfterViewInit, Output, ViewChild } from '@angular/core';
import { Certificate } from 'crypto';
import { CommunicationService } from "../services/communication.service";
import { ControllerService } from '../services/controller.service';
import { ConfigService } from '../services/config.service';
import { KHASystemService } from '../services/systems/kha-systems.service';
import { LanguageService } from '../services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { validateVerticalPosition } from '@angular/cdk/overlay';
import { DomSanitizer } from '@angular/platform-browser';
import { GameService } from '../services/game.service';
import html2canvas from 'html2canvas';
import { MatIconRegistry } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

declare var BABYLON;
@Component({
  selector: 'app-ship-detail',
  templateUrl: './ship-detail.component.html',
  styleUrls: ['./ship-detail.component.scss'],
  providers: [DatePipe]
})
export class ShipDetailComponent implements OnInit, AfterViewInit {
  @ViewChild('datauxview', { static: true }) public datauxview: any;
  shipData: any = '';
  @Input() testMode: any = "";
  @Input() mvScreenType: any = "compartment";
  @Input() shipHazardList: any;
  @Input() appMode: any;
  @Input() compToggle:any;
  @Output() loadPdf: EventEmitter<any> = new EventEmitter<any>();
  displayedColumns: string[] = ['code', 'compartmentName', 'componentName', 'groupName', 'statusName', 'startDate'];
  dataSource: any = [
    { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
    { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
    { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
    { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
    { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
    { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
    { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
    { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
    { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
    { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
  ];
  selectedKha: any = "compartments";
  broadcastIframeSubs: any;
  compartmentsCommentdetatils: any = [];
  statusMenu = [
    { value: '#FF0000', name: 'BLOCKED' },
    { value: '#FFBF00', name: 'INPROGRESS' },
    { value: '#00FF00', name: 'COMPLETED' },
  ]
  statusUpdated;
  commentDetails: any;
  highlightCompState = false;
  mname: any;
  compartmentLoad: any;
  layoutCloseDetailData: any = [];
  fillStatus: boolean = false;
  showOverlayPdfViewer: boolean = false;
  pdfPageNo: number;
  pageNo: any = ['1234', '1256', '1325', "1243", '1245', '1265', '1267', "1276", '1279', '1265'];
  @Input() set shipDetailPanelData(v: any) {
    if (v != '') {
      this.shipData = v;
    }
  }
  lm_default = 0x0FFFFFFF
  slms_mode = true;
  imgSrc: any;
  broadcastSubs: any;
  showLoading: boolean = true;
  selectedDemo: string = "";
  process_txt: string = "Processing ";
  statusList: any = [];
  initialized = false;
  dfx;
  scene;
  shipCompartment: any;
  camviews = "";
  ernOverlayMode: boolean = false;
  overlayHeading: any = "";
  overlaySubHeading: any = "";
  loadUrl: any;
  khaConfig
  materialStatusWindow: boolean = false;
  compCommentWindow: boolean = false;
  controlButton = true;
  // groupMode:any=false;
  arrControlBtnProps = [
    { name: 'home', icon: 'home', state: true },
    { name: '2D', icon: 'dimension', state: false },
    { name: 'zoomin', icon: 'add', state: true },
    { name: 'zoomout', icon: 'remove', state: true },
    { name: 'drag', icon: 'swipe', state: false, ticon: 'do_not_touch' },
    { name: 'reset', icon: 'refresh', state: false, ticon: 'refresh' },
    { name: 'marker', icon: 'marker', state: false, ticon: '' },
    { name: 'cutmarker', icon: 'create', state: false, ticon: '' },
    { name: 'screenshot', icon: 'screenshot_monitor', state: false, ticon: 'screenshot_monitor' },
    // { name: 'exit', icon: 'exit_to_app', state: false, ticon: 'exit_to_app' }
  ];
  khaComps: any;
  statusMode: boolean = false;
  ship_settings = {
    "mats": "./systems_material.gltf",
    "ernmodel": "./ern_fleetway_halifax.glb"
  }
  ship_settings_slms = {
    "mats": "./systems_material.gltf",
    "kys": "./slms/kys_halifax.glb",
    "ernmodel": "./slms/ern_fleetway_halifax.glb"

  }
  ship_objects = {
    "shapes": [
      {
        "mhfx": {
          "model": "root_kys_halifax",
          "material": "custom-included",
          "size": 1
        }
      },
      {
        "ernhfx": {
          "model": "root_ern_fleetway_halifax",
          "material": "custom-included",
          "size": 1
        }
      }
    ],
    "objects": [
      {
        "type": "static",
        "parent": "",
        "name": "ehfx",
        "model": "mhfx",
        "place": {
          "pos": {
            "x": 0,
            "y": 0,
            "z": 0
          },
          "rot": {
            "x": 0,
            "y": 0,
            "z": 0
          }
        }
      },
      {
        "type": "static",
        "parent": "",
        "name": "ernhfx",
        "model": "ernhfx",
        "place": {
          "pos": {
            "x": 0,
            "y": 0,
            "z": 0
          },
          "rot": {
            "x": 0,
            "y": 0,
            "z": 0
          }
        }
      }
    ]
  }

  statusColorCode: any = [{ "name": "Red", "key": "red", "color": "#ff0000" }, { "name": "Yellow", "key": "yellow", "color": "#ffff00" }, { "name": "Transparent", "key": "transparent", "color": "#ababb2" }];
  selectedStatus: any = '';
  statusMessage: any = '';
  gameManager
  cam_mode = '3D';
  isMouseDown
  mousestate = "up";
  doubleClick = 0;
  selectedKhaSystems: any;
  materialmap: any = {};
  lightSettings;
  pcsDemos: any = [];
  showBlockLoading: boolean = false;
  setInterval: any;
  isMaterialAppLoaded: boolean = false;
  allShipElements: any;
  canvasDragChange: any = false;
  khasystem_name: any = "";
  statusChange = false;
  compComments: any = '';
  isCommentTyped = false;
  groupWindow: any = false;
  groupState: any;
  groupName: any;
  groupData: any;
  layoutData = []
  groupList = [];
  drawing = false;
  markerColor = "#ff0000";
  markerWidth = 1;
  markerShape = 'rect'
  drawIcons = { "free": "brush", "rect": "check_box_outline_blank", "circle": "radio_button_unchecked", "polygon": "label_outline" }
  statusWindow: any = false;
  statusHeading = "Create Status"
  statusName: any;
  statusColor: any = "#f5f5f5"
  statusListData: any;
  statusId: any;
  btnStatus = 'Create'
  appGameModeContrl: any;
  @Input() set appGameMode(v: any) {
    if (v == true) {
      this.appGameModeContrl = true;
    }
    if (v == false) {
      this.appGameModeContrl = false;
    }
  }
  constructor(private CommunicationServ: CommunicationService, private datepipe: DatePipe,
    private ctrlServ: ControllerService,
    private configService: ConfigService,
    private _khaConfig: KHASystemService,
    private translate: TranslateService,
    private language: LanguageService,
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry
  ) {
    this.matIconRegistry.addSvgIcon(
      `hexagon-icon`,
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/hexagon-icon.svg")
    );
    this.matIconRegistry.addSvgIcon(
      `hexagon-icon-active`,
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/hexagon-icon-active.svg")
    );
    this.khaConfig = this._khaConfig;
    this.statusList = this.ctrlServ.statusList;
    this.khaComps = this.ctrlServ.comps;

    this.language.languageChange.subscribe(props => {
      console.log("language", props);
      this.translate.use(props);
    })
    this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
  }

  /* * * * *
  * method for communicate event instance with data to access all components
  * * * * * */
  broadcastInfo(data: any) {
    this.CommunicationServ.getInstance().next(data);
  }

  broadcastIframeInfo(data: any) {
    this.CommunicationServ.createIframeInstance(data);
  }

  buttonclick(row, index) {
    this.arrControlBtnProps[index].state = !this.arrControlBtnProps[index].state;
    this.controlToolEvent(row);
  }

  controlToolEvent(control) {
    if (control.name === 'home') {
      let currentTab = this.ctrlServ.matCurrentTab;
      if (currentTab === 'compartment') {
        if (this.camviews) {
          this.moveCameraTo(null, this.camviews);
        } else {
          this.onChangeCameraPosition(control.name);
        }
      } else {
        this.onChangeCameraPosition(control.name);
      }
    } else if (control.name === '2D') {
      let dimension = control.state ? '2D' : '3D';
      this.onChangeCameraMode(dimension);
    } else if (control.name === 'zoomin' || control.name === 'zoomout') {
      let zoomPosition = control.name === 'zoomin' ? ']' : '[';
      this.Zoom(zoomPosition);
    } else if (control.name === 'drag') {
      if (control.state) {
        this.khaConfig.dragMode = true;
        this.khaConfig.enableDrag();
      } else {
        this.khaConfig.dragMode = false;
        this.khaConfig.removeDragAll();
      }
    } else if (control.name === 'reset') {
      this.khaConfig.clearDrag();
      if (this.arrControlBtnProps[4].state) {
        this.khaConfig.enableDrag();
      }
    } else if (control.name === 'marker') {
      this.khaConfig.draw_select_mode = this.arrControlBtnProps[6].state;
      if (this.khaConfig.draw_select_mode) {
        this.arrControlBtnProps[7].state = !this.khaConfig.draw_select_mode;
        this.khaConfig.cut_mode = !this.khaConfig.draw_select_mode;
      }
    } else if (control.name === 'cutmarker') {
      this.khaConfig.cut_mode = this.arrControlBtnProps[7].state;
      if (this.khaConfig.cut_mode) {
        this.arrControlBtnProps[6].state = !this.khaConfig.cut_mode;
        this.khaConfig.draw_select_mode = !this.khaConfig.cut_mode;
      }
    } else if (control.name == 'exit') {
      this.arrControlBtnProps[9].state =!this.arrControlBtnProps[9].state;
      this.broadcastInfo({ src: 'sidepanel', event: 'exit', data: this.arrControlBtnProps[9].state, comp: [] });
    } else if (control.name == 'screenshot') {
      this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });
      if (this.selectedLayoutList) {
        if (this.reconstructLayoutData.length > 0) {
          this.selectedLayoutList['tagPoints'].forEach(element => {
            let indx = this.reconstructLayoutData.findIndex(e => e['id'] == element['id'] && e['layoutId'] == this.selectedLayoutList['_id']);
            if (indx > -1) {
              if (this.reportTableList.length > 0) {
                let idx = this.reportTableList.findIndex(e => e['id'] == this.reconstructLayoutData[indx]['id'] && e['layoutId'] == this.reconstructLayoutData['layoutId']);
                if (idx == -1) {
                  this.reportTableList.push(this.reconstructLayoutData[indx]);
                }
              } else {
                this.reportTableList.push(this.reconstructLayoutData[indx]);
              }
            }
          });
        }
        console.log("collectScreenshot", this.reportTableList);
        this.getTableList(this.reportTableList);
      } else {
        this.collectScreenshot();
      }



    }

  }
  reconstructLayoutData: any;
  reportTableList = [];
  reportScreenshotList: any = [];
  reportState: any = false;
  collectScreenshot() {
    this.showLoading = true;
    this.reportState = true;

    let elem = document.getElementById("notesTag");
    //  let elem1 =  document.getElementById("noteTag");
    if (elem) {
      setTimeout(() => {
        html2canvas(document.getElementById("notesTag"), { scale: 1, backgroundColor: '#ffffff00' }).then(canvas => {

          //    debugger;

          //   /// document.body.appendChild(canvas);


          var canvas1 = canvas.toDataURL('image/png')
          this.dfx.getSnapshot({
            callback: (canvasURL) => {
              var img1 = new Image(); // width, height values are optional params
              img1.src = canvasURL;
              img1.onload = () => {
                let canvas2 = this.resizeImgToPDF(img1);
                this.overlapImage(canvas1, canvas2)


              }
            }
          });

        })

      }, 500);


    } else {
      this.dfx.getSnapshot({
        callback: (canvasURL) => {
          var img1 = new Image(); // width, height values are optional params
          img1.src = canvasURL;
          img1.onload = () => {
            var reportData = { id: this.selectedLayoutList ? this.selectedLayoutList['_id'] : '', file: this.resizeImgToPDF(img1) };
            this.reportScreenshotList.push(reportData);
            console.log("reportScreenshotList", this.reportScreenshotList);
            this.broadcastInfo({ src: 'material', event: 'screenshot', data: this.reportScreenshotList, tableData: this.layoutTableList });
            this.showLoading = false;
            this.reportState = false;
            this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });

          }
        }
      });
      // this.showLoading=false;
      // this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });
    }

  }
  layoutTableList: any = [];
  getTableList(data) {
    this.layoutTableList = [];
    if (data.length > 0) {
      data.forEach(element => {
        if (this.layoutTableList.length > 0) {
          let idx = this.layoutTableList.findIndex(e => e.layoutId == element.layoutId);
          if (idx == -1) {
            // var elem = document.getElementById("report_tbl_"+element.layoutId);
            // html2canvas(elem, { scale: 1, backgroundColor: '#ffffff' }).then(canvas => {

            //   const contentDataURL = canvas.toDataURL('image/png');
            //   element['file']=contentDataURL;
            this.layoutTableList.push(element);
            // });
          }
        } else {
          this.layoutTableList.push(element);

        }
      });
      // return this.layoutTableList;
      setTimeout(() => {
        this.collectScreenshot();
        // this.getGDataURL();
      }, 500);

    }
  }

  getGDataURL() {
    if (this.layoutTableList.length > 0) {
      this.layoutTableList.forEach((element, i) => {
        var elem = document.getElementById("report_tbl_" + element.layoutId);
        console.log("getGDataURL", elem, this.layoutTableList)
        // if(!this.layoutTableList[i]['file']){
        html2canvas(elem, { scale: 1, backgroundColor: '#ffffff' }).then(canvas => {
          const contentDataURL = canvas.toDataURL('image/png');
          this.layoutTableList[i]['file'] = canvas;
          if (i == this.layoutTableList.length - 1) {
            this.collectScreenshot();
          }
        });
        // }else{
        //   if(i==this.layoutTableList.length-1){
        //     this.collectScreenshot();
        //   }
        // }

      });
    }

  }
  getDataSource(id) {
    let list = [];
    if (this.reconstructLayoutData.length > 0) {
      this.reconstructLayoutData.forEach(element => {
        if (id) {
          if (element['layoutId'] == id) {
            list.push(element);
          }
        }
      });
    }
    // console.log("getDataSource",list)
    return list;
  }

  getDate(date) {
    if (date) {
      return this.datepipe.transform(date, "MMM d, y, h:mm a")
    } else {
      return "";
    }

  }
  overlapImage(img1, img2) {
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    var image1 = new Image();

    var temp = new Image();
    temp.src = img2;
    let w = this.preview_pdf_width;
    let h = this.preview_pdf_height;
    // Set width and height
    canvas.width = w;
    canvas.height = h;
    // Draw the image
    var width = temp.naturalWidth;
    var height = temp.naturalHeight;
    let containerRatio = h / w;
    temp.onload = function () {
      width = temp.naturalWidth;
      height = temp.naturalHeight;

      console.log('imgWidth: ', width);
      console.log('imgHeight: ', height);
      let imgRatio = height / width;

      if (imgRatio > containerRatio) { // image's height too big
        height = width * containerRatio;
      } else { // image's width too big
        width = height / containerRatio;
      }
    };
    // let width = temp.naturalWidth;
    // let height = temp.naturalHeight;

    // image1.src=img1;
    // image2.src = img2;
    // image1.onload = function() {
    //   // canvas.width = image1.width;
    //   // canvas.height = image1.height;
    //   context.drawImage(image1, 0, 0);

    // };
    // image1.src=img1;
    // image2.onload = function() {
    //   // context.globalAlpha = 1.0;
    //   context.drawImage(img1, 100, 100);
    //   // context.globalAlpha = 0.5; //Remove if pngs have alpha
    //   context.drawImage(img2, 100, 100);
    // };        
    // image2.src = img2;
    // image1.src=img1;
    // var width = 600;
    // var height = 300;
    image1.onload = function () {
      context.drawImage(image1, 0, 0, width, height);

      var image2 = new Image();
      // blackImage.src=img2;
      image2.onload = function () {
        context.globalCompositeOperation = "screen";
        context.drawImage(image2, 0, 0, width, height);
      }
      image2.src = img1;

    };
    image1.src = img2;
    setTimeout(() => {
      // return canvas.toDataURL('image/png');
      var reportData = { id: this.selectedLayoutList ? this.selectedLayoutList['_id'] : '', file: canvas.toDataURL('image/png') };
      this.reportScreenshotList.push(reportData);
      // this.reportScreenshotList.push("data:image/png;base64,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");
      console.log("reportScreenshotList", this.reportScreenshotList);
      this.broadcastInfo({ src: 'material', event: 'screenshot', data: this.reportScreenshotList, tableData: this.layoutTableList });
      this.showLoading = false;
      this.reportState = false;
      this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });
    }, 1000);

  }

  /* * * * *
  * method for resize umage to pdf
  * * * * * */
  preview_pdf_width = window.innerWidth;
  preview_pdf_height = window.innerHeight;
  resizeImgToPDF(img) {
    let w = this.preview_pdf_width;
    let h = this.preview_pdf_height;
    // Create canvas
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    // Set width and height
    canvas.width = w;
    canvas.height = h;
    // Draw the image
    let containerRatio = h / w;
    let width = img.naturalWidth;
    let height = img.naturalHeight;
    let imgRatio = height / width;

    if (imgRatio > containerRatio) { // image's height too big
      height = width * containerRatio;
    } else { // image's width too big
      width = height / containerRatio;
    }

    let s = {
      width: width,
      height: height,
      offsetX: (img.naturalWidth - width) * .5,
      offsetY: (img.naturalHeight - height) * .5
    };
    ctx.drawImage(img, s.offsetX, s.offsetY, s.width, s.height, 0, 0, w, h);
    return canvas.toDataURL('image/jpeg', 1.0);
  }
  /**
  * onChange camera mode
  * * */
  onChangeCameraMode(camView) {
    this.cam_mode = camView;
    if (this.cam_mode == '2D') {
      this.onChangeCameraPosition('top');
    }
    this.datauxview.CameraMode(camView);
    if (this.cam_mode == '3D') {
      if (this.khaConfig.khamode === 'system') {
        setTimeout(() => {
          this.onChangeCameraPosition('home');
        }, 1300);
      }
    }
  }

  /**
  * onChange camera position
  * * */
  onChangeCameraPosition(camView) {
    if (camView === 'home') {
      this.onChangeCamView(camView);
    }
    if (this.cam_mode == '2D') {
      camView = 'ortho' + camView
    }
    this.datauxview.Camera(camView);
  }

  /**
  * onChange camera view
  */
  onChangeCamView(v, vobj = false) {
    let currentTab = this.ctrlServ.matCurrentTab;
    if (currentTab !== 'section') {
      this.moveCameraTo(null, v)
    }
  }

  /**
  * move camera
  */
  moveCameraTo(el, view = null) {
    let dfx = this.datauxview.getDatascape();
    let _view = view;
    // if(dfx!=null){
    dfx.moveCamera(_view);
    // }

  }

  /**
  * Zoom event to zoom in / out the venue
  */

  Zoom(key) {
    this.isMouseDown = true;
    this.datauxview.startZoom(key);
  }
  stopZoom() {
    this.isMouseDown = !true;
    this.datauxview.stopZoom();
  }
  @HostListener('document:pointerdown', ['$event'])
  handlePointerDownEvent(event: MouseEvent) {
    this.mousestate = "down";
    if (event.target['nodeName'] === 'CANVAS') {
      if (!this.gameManager) {
        this.onMouseDownN();
      }
      let drawaction = (this.khaConfig.draw_select_mode || this.khaConfig.cut_mode) && !this.khaConfig.marker_select_mode
      if (drawaction && (event.which === 1 || event.button === 0)) {
        let dr = this.khaConfig.doDraw()
        this.drawing = dr;
      }
      // for color picker tool outside close 
      let dom: any = document.getElementsByClassName("btn btn-custom-ok")[0];
      if (dom) {
        dom.click();
      }
    }
  }
  @HostListener('document:pointermove', ['$event'])
  handlePointereMoveEvent(event: MouseEvent) {
    if (event.target['nodeName'] === 'CANVAS') {
      if (this.mousestate === 'down') {
        this.mousestate = "drag";
      }
      if (this.mousestate === 'drag') {
        let drawaction = (this.khaConfig.draw_select_mode && this.markerShape != 'polygon') || this.khaConfig.cut_mode
        if (drawaction && this.drawing) {
          this.khaConfig.doDraw()
        }
      }
    }
    // this.onMouseMoveN(event)
  }
  @HostListener('document:pointerup', ['$event'])
  handlePointereUpEvent(event: MouseEvent) {
    if (this.mousestate === 'down') {
      if ((<HTMLInputElement>event.target).id == "renderCanvas") {
        if (event.which === 1 || event.button === 0) {
          if (!this.gameManager) {
            setTimeout(() => {
              this.canvasPickedObject(event);
            }, 201)
          }
        }
      }
    }
    if ((<HTMLInputElement>event.target).id == "renderCanvas") {
      if (this.drawing) {
        let drawaction = this.khaConfig.draw_select_mode || this.khaConfig.cut_mode
        if (drawaction && this.drawing) {
          let dr = this.khaConfig.stopDraw()
          this.drawing = dr;
        }
      }
      if (!this.gameManager) {
        this.onMouseUpN();
      }
    }
    this.mousestate = "up";
  }

  @HostListener('document:mouseup', ['$event'])
  handleMouseUpEvent(event: MouseEvent) {
    if (this.isMouseDown) {
      this.stopZoom();
    }
    this.mousestate = "up"
  }

  onMouseDownN(d = 1) {
    this.doubleClick += 1;
  }

  onMouseUpN() {
    setTimeout(() => {
      this.doubleClick = 0;
    }, 200);
  }
  quizWindowClose() {
    this.quizPanel = false;
    delete this.quizComment;
    // this.khaConfig.hideHighlightSelection();
    this.selectedKhaSystems = null
    delete this.pickedMeshObj;
    delete this.notesElement;
    delete this.notesComment;
  }
  checkQuiz() {
    var code = this.selectedKhaSystems.code.toLowerCase() == "--" ? this.selectedKhaSystems.desc.toLowerCase() : this.selectedKhaSystems.code.toLowerCase();

    if (code == this.quizComment.toLowerCase()) {
      // alert('correct');
      this.quizResult = 'Correct';
      this.quizList[this.quizOrder - 1]['status'] = true;
      this.quizList[this.quizOrder - 1]['result'] = 1
    } else {
      // alert('wrong');
      this.quizResult = 'Incorrect';
      this.quizList[this.quizOrder - 1]['status'] = true;
      this.quizList[this.quizOrder - 1]['result'] = 0
    }

  }
  clearQuiz() {
    // if( this.quizResult == 'Correct'){

    // }
    // if(this.quizOrder==4){
    //   console.log("this.quizList",this.quizList)
    //   this.quizWindowClose();
    // }
    if (this.quizOrder == this.quizList.length) {
      this.quizWindowClose();
      console.log("result", this.quizList);
      this.broadcastInfo({ src: 'sidepanel', event: 'scoreBoard', data: this.quizList });
    } else {
      this.quizOrder = this.quizOrder + 1;
      this.quizOrderList();

    }
    delete this.quizComment;
    delete this.quizResult;
  }

  quizResult: any;
  quizPanel: any = false;
  quizComment: any;
  // layList:any=[];
  pickedMeshObj: any;
  selectedMesh: any;
  canvasPickedObject(e) {
    if (this.appMode == "kys-quiz-mode") {
      return;
    }
    if (this.dfx) {
      delete this.pickedMeshObj;
      delete this.selectedMesh;
      const hit = this.dfx.getHitPosition();
      var mesh = hit.pickedMesh;
      if (mesh != null && this.doubleClick === 0) {
        let mname = this.ctrlServ.getMeshName(mesh.name);
        if (this.khaConfig.exitRouteOn) {
          this.khaConfig.hideExitRoutes();
          this.khaConfig.showExitRoute(mname);
        }
        if (mesh.name.includes('_slicer') && mesh.name.includes('marker_')) {
          this.khaConfig.selectedMarker = mesh.name.split("_slicer")[0];
          if (Object.keys(this.khaConfig.cselects).length === 0) return;
          let markerObj = this.khaConfig.cselects[this.khaConfig.selectedMarker];
          this.markerColor = markerObj[7] || "#ff0000";
          this.fillStatus = !!(markerObj[9])
          this.khaConfig.draw_select_fill = this.fillStatus;
        } else {
          // this.khaConfig.highlightSelection(mesh,4,null,true);
        }
        if (this.khaConfig.cut_mode || this.khaConfig.draw_select_mode) {
          //this.khaConfig.applyCutoutAt(hit.pickedPoint, hit.pickedMesh,null,hit.faceId);
          if (this.markerShape === 'polygon' && this.drawing) {
            return;
          }
          //return
        }

        this.khaConfig.hideHighlightSelection(this.selectedMesh);
        this.selectedMesh = mesh;
        // this.khaConfig.highlightSelection(mesh,4,null,true);
        //this.khaConfig.highlightSelection(mesh,0.05,null,true);
        let str = mesh.name;
        var meshId = mesh.id
        if (this.selectedLayoutList) {
          let tagId = mesh.name ? mesh.name.split('-')[1] : '';
          if (tagId) {
            if (this.selectedLayoutList['tagPoints'].length > 0) {
              let idx = this.selectedLayoutList['tagPoints'].findIndex(e => e.id == tagId);
              if (idx > -1) {
                if (this.khaConfig.layoutTagList.length > 0) {
                  let inx = this.khaConfig.layoutTagList.findIndex(e => e.id == tagId);
                  if (inx > -1) {
                    // this.khaConfig.showLayoutTag(this.selectedLayoutList['tagPoints'][idx],false);
                    this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: this.selectedLayoutList['tagPoints'][idx], status: false });
                  } else {
                    // this.khaConfig.showLayoutTag(this.selectedLayoutList['tagPoints'][idx],true);
                    this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: this.selectedLayoutList['tagPoints'][idx], status: true });
                  }
                } else {
                  // this.khaConfig.showLayoutTag(this.selectedLayoutList['tagPoints'][idx],true);
                  this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: this.selectedLayoutList['tagPoints'][idx], status: true });
                }
                return;
              }
            }
          }
        }
        let narr = str.split(".");
        let nstr = narr[narr.length - 1];
        let a = nstr.split("+")
        let name = a[1] ? (a[1] + " (" + (a[0].split("_")[1]) + ")") : a[0];
        console.log("nstr ", nstr);
        this.khaConfig.selectedTagMesh = nstr;
        delete this.selectedKhaSystems;
        let dom: any = document.getElementsByClassName("mat_nm_label")[0];
        if (dom) {
          dom.style.display = "none";
        }
        if(this.compToggle&&this.compToggle['key']=='kys-exit'){
          return;
        }
        this.getSelectedKhaSystemsLabel(mesh, a);
        // if(this.LayoutMode){
        let selectedLayoutId = this.selectedLayoutList ? this.selectedLayoutList['_id'] : '';
        let uid = this.getUID();
        this.pickedMeshObj = { id: uid, shape: 'sphere', hit: { x: hit.pickedPoint.x, y: hit.pickedPoint.y, z: hit.pickedPoint.z }, name: name, partId: nstr, parentId: selectedLayoutId, code: this.selectedKhaSystems['code'], partMeshId: meshId };
        // }
        //   this.selectedLayoutList['tagPoints'].push(obj)
        //   // this.layList.push(obj);
        //   console.log("lay",this.selectedLayoutList);

        //   this.updateLayout(this.selectedLayoutList['_id'],this.selectedLayoutList);
        //   let mesh = this.khaConfig.getPartMesh(obj,(e)=>{
        //     if(e){
        //       this.khaConfig.createMatObjectPoint(obj,e);
        //       this.khaConfig.updateAbsolutePosition(this.selectedLayoutList['tagPoints'])
        //     }

        //   });
        // }else{
        console.log("pickedMeshObj", this.pickedMeshObj)
        if (this.appMode == "kys-quiz-mode") {
          console.log("ship", this.selectedKhaSystems);
          // if(this.selectedKhaSystems.code!="--"){
          this.quizPanel = true;
          // }

          return;
        }


        this.khaConfig.createMatObject('cube', hit, name);
        // }
      } else {
        // this.khaConfig.hideHighlightSelection();
        if (this.khaConfig.exitRouteOn) {
          this.khaConfig.hideExitRoutes();

        }
        this.selectedKhaSystems = null
        this.khaConfig.showMatObjectTag(mesh, false);
        delete this.pickedMeshObj;
        delete this.notesElement;
        delete this.notesComment;
      }
    }

  }


  getSelectedKhaSystemsLabel(e, a) {
    this.selectedKhaSystems = { color: "#00000000" };
    let code = a[1] ? ((a[0].split("_")[1])) : "--";
    let desc = a[1] ? (a[1]) : a[0];
    let mat = e.mid;
    this.selectedKhaSystems.id = e['id'];
    this.selectedKhaSystems.code = code;
    this.selectedKhaSystems.desc = desc;
    this.mname = this.ctrlServ.getMeshName(e['id']);
    let floorColor = this.khaConfig.checkDeckFloor(this.mname);
    this.highlightCompState = floorColor;
    this.componentLoad()
    console.log("floor", floorColor)
    let _mesh = this.selectedMesh;
    if (this.selectedMesh.name.includes("_slicer") || this.selectedMesh.name.includes("_marker")) {
      _mesh = null;
      // this.khaConfig.hideHighlightSelection();
    }
    if (_mesh) {
      this.khaConfig.highlightSelection(_mesh, 4, null, true, floorColor);
    }
    if (this.materialmap[mat]) {
      this.selectedKhaSystems.color = this.materialmap[mat]
    }
    if (this.statusMode) {
      let colors = { "red": "#ff0000", "yellow": "#ffff00", "transparent": "#ababb2" };
      let statusColor = this.getStatusColorCode(e['id']);
      if (statusColor) {
        this.selectedStatus = statusColor;
        let color = colors[statusColor];
        this.materialmap[mat] = color;
        this.selectedKhaSystems.color = color;
      }
    } else {
      if (mat && !this.materialmap[mat]) {
        let m = this.scene.getMaterialByName(mat);
        let c = m.albedoColor;
        let r = Math.round(c.r * 255);
        let g = Math.round(c.g * 255);
        let b = Math.round(c.b * 255);
        let hex = this.rgbToHex(r, g, b);
        this.materialmap[mat] = hex;
        this.selectedKhaSystems.color = hex;
      }
    }
    delete this.selectedGroupData;
    this.notesElement = {};
    // this.selectedGroup();
    // this.selectedNotes();
    this.selectedLayout();
  }

  getStatusColorCode(id) {
    let material;
    for (let mat of Object.keys(this.khaConfig.systemSubComps)) {
      let comps = this.khaConfig.systemSubComps[mat];
      const found = comps.some(m => m.id === id);
      if (found) {
        material = mat;
        break;
      }
    }
    return material;
  }

  setVenueLightIntensity(i = 4) {
    this.lightSettings = [{ direction: { x: -0.85, y: -0.40, z: 0.35 }, diffuse: { r: 0.65, g: 0.65, b: 0.65 }, specular: { r: 0, g: 0, b: 0 } }, { direction: { x: 0.75, y: -0.40, z: -0.45 }, diffuse: { r: 1.0, g: 1.0, b: 1.0 }, specular: { r: 0, g: 0, b: 0 } }, { direction: { x: 0.15, y: -0.40, z: 0.50 }, diffuse: { r: 1.0, g: 1.0, b: 1.0 }, specular: { r: 0, g: 0, b: 0 } }];
    this.dfx = this.datauxview.getDatascape();
    this.scene = this.dfx.getCamera().getScene();
    let lights = this.scene.lights;
    lights.forEach((light) => {
      light.intensity = i;
    })

  }

  /* * *
  * method id default config is loadded/not
  * * */
  checkAppIsLoaded() {
    let animation = (timer) => {
      if (this.isMaterialAppLoaded) {
        this.broadcastInfo({ src: 'kys', event: 'updateGroup', data: this.groupList });
        this.broadcastInfo({ src: 'material', event: 'material_init_load', state: false, key: "" });
        cancelAnimationFrame(this.setInterval);
      } else {
        this.setInterval = window.requestAnimationFrame(animation);
      }
    }
    this.setInterval = window.requestAnimationFrame(animation);
  }

  initIframeMessage() {
    this.broadcastIframeInfo({ iframeConnection: 'init-nsc-connection', event: 'nsc-init', data: '', key: "" });
  }
  selectedLayoutList: any;
  temporaryCommentData: any;
  ngOnInit() {
    this.initIframeMessage();
    this.showBlockLoading = true;
    this.ctrlServ.isMaterialAppLoaded = false;
    this.checkAppIsLoaded();
    window['shipcomp'] = this;
    if (this.shipHazardList != undefined) {
      this.selectedKha = this.shipHazardList['area'].split(" ").join("").toLowerCase();
      this.ctrlServ.selectedKha = this.selectedKha;
    }
    this.broadcastSubs = this.CommunicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "khaservice") {
          if (data.event === 'showloader') {
            let obj = data['data'];
            this.showLoading = true;
            this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });
            this.selectedDemo = obj;
          }
          if (data.event === 'hideloader') {
            let obj = data['data'];
            this.showLoading = !true;
            this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showLoading' } });
            this.selectedDemo = "";
            if (obj) {
              this.shipCompartment = obj;
            }
          }
          if (data.event === 'updatehomeview') {
            if (data['data']) {
              this.camviews = data['data'];
            }
          }
          if (data.event === 'loadERNTreeModel') {
            if (data['data']) {
              this.onLoadERNTree(data);
            }
          }
          if (data.event === 'loadNSCTreeModel') {
            if (data['data']) {
              this.onLoadNSCTree(data);
            }
          }
          if (data.event === 'hideLayoutTag') {
            this.selectedLayoutList = data.data
            //this.processMutipleComparment(this.selectedLayoutList, true);

          }
        }
        if (data.src === "controlpanel") {
          if (data.event === 'loadcompartment') {
            this.shipCompartment = data['data'];
            this.commentWindowClose();
            if (data['key']) {
            }
          }
          if (data.event === 'reset_drag') {
            if (data['key']) {
              this.shipCompartment = (data['key'] === 'system' ? null : this.shipCompartment);
            }
          }
          if (data.event === "reset_drag") {
            if (this.arrControlBtnProps[4].state) {
              this.arrControlBtnProps[4].state = !this.arrControlBtnProps[4].state;
              this.khaConfig.dragMode = false;
              this.khaConfig.clearDrag();
            }
          }
          if (data.event == 'showhidesubsystem') {
            if (!data.data && this.selectedKhaSystems) {
              if (data.key[0] == this.selectedKhaSystems.model[0]) {
                this.khaConfig.showMatObjectTag(null, false);
              }
            }
          }
          if (data.event === 'showsystemcolors') {
            this.khaConfig.showMatObjectTag(null, false);
            this.statusMode = data['key'] == 'status' ? true : false;
          }
          if (data.event === 'load-mutiple-compartment') {
            // this.khaConfig.matTagClear();
            // this.selectedNotes()
            this.clearGroup();
            this.LayoutMode = false;
            var layout = data['data'];
            var layoutData = layout['tagPoints']
            layoutData.forEach(tagcom => {
              var tag = tagcom.tagComments
              if (tag && tag.statusId) {
                let filteredStatus = this.statusListData.filter(m => m._id == tag.statusId);
                var statusData = filteredStatus[0]
                if (statusData != undefined) {
                  tag.status.name = statusData.name;
                  tag.status.value = statusData.value;
                } else {
                  tag.status.name = '';
                  tag.status.value = '';
                }
                if (statusData == undefined) {
                  tag.status.name = '';
                  tag.status.value = '';
                }
              }
            });
            console.log("selectedLayoutList", data['data']);
            this.selectedLayoutList = data['data'];
            this.khaConfig.khamode = "compartment";
            this.processMutipleComparment(this.selectedLayoutList, data['key']);
            // this.createtagPoints();
            // this.getGroupItem();
          }
          if (data.event === 'load-update-compartment') {
            this.selectedLayoutList = data['data'];
            if (this.pickedMeshObj) {
              this.pickedMeshObj['parentId'] = this.selectedLayoutList['_id']
            }
            // this.getGroupItem();
          }
          if (data.event === 'clear-layout-window') {
            // console.log("636","reset")
            this.closeLayoutScreen();
          }
          if (data.event === 'delete-layout-data') {
            let obj = data['data'];
            if (obj) {
              this.deleteLayout(obj);
            }
          }
          if (data.event === 'clear-group-window') {
            this.clearGroup();
          }
          if (data.event === 'delete-group-data') {
            console.log("delete-group-data", data['data'])
            let obj = data['data'];
            if (obj) {
              this.deleteGroup(obj);
            }
          }
        }
        if (data.src === "sidepanel") {
          if (data.event == "report-table") {
            this.reconstructLayoutData = data['data'];
          }
          if (data.event == "createGroup") {
            this.openGroupPanel("new");
          }
          if (data.event == "updateGroup") {
            console.log("update", data['data'])
            this.openGroupPanel("edit", data['data']);
          }
          if (data.event == "updateStatus") {
            console.log("update", data['data'])
            var statusData = data['data']
            this.statusName = statusData.name;
            this.statusColor = statusData.value;
            this.statusId = statusData._id;
            this.btnStatus = 'Update';
            this.statusHeading = 'Update Status';
            this.statusWindow = true;
          }
          if (data.event == "updateStatusColor") {
            console.log("update", data['data'])
            var statusData = data['data']
            if (statusData == 'statusReload') {
              this.getStatusData();
            }
          }
          if (data.event == "updateStatusColorData") {
            var statusData = data['data']
            if (statusData == 'updateStatusColor') {
              this.statusUpdateDetails();
            }
          }
          if (data.event == 'update-screenshot') {
            this.reportScreenshotList = data['data'];
          }
          if (data.event == "update-report-table") {
            this.reportTableList = data['data'];
          }
          if (data.event == "resetLayout") {
            this.clearLayout();
          }
          if (data.event === 'groupMultipleLoadCompartment') {
            // this.khaConfig.matTagClear();
            this.clearLayout();
            this.khaConfig.groupMode = true;
            let obj = data.data || [];
            if (obj.length > 0) {
              let comp = obj[obj.length - 1];
              let shipComp = { name: comp.name, code: comp.code };
              this.shipCompartment = shipComp;
            }
            this.broadcastInfo({ src: 'controlpanel', event: 'groupMultipleLoadCompartment', data: data.data, key: "" });
          }
          if (data.event === "pathAnim") {
            if (data.key) {
              data['gameid'] = 1;
              if (data['data'] === 'demo3') {
                data['data'] = 'demo2';
                data['gameid'] = 2;
              }
              this.initGameMode(data);
              this.gameManager.animStartState=true;
            } else {
              if (this.gameManager) {
                this.gameManager.stopPathAnimDemo();
              }
            }
          }
          if (data.event === "showinfo") {
            if (this.gameManager) {
              this.gameManager.info_mode = data.key;
            }
          }
          if (data.event === 'changeshipcomp') {
            if (this.khaConfig.datauxview) {
              this.selectedKha = this.ctrlServ.selectedKha;
              if (data['comp'] !== undefined) {
                this.ctrlServ.selectedSysComp = data.comp;
              }
              let area = this.selectedKha.split(" ").join("").toLowerCase();
              this.khaConfig.selectedKha = area;
              this.khaConfig.khamode = "system";
              this.khaConfig.setSystemConfig(area);
              this.khaConfig.resetSubSystems();
              this.khaConfig.changeKHA(area);
              this.onChangeCameraPosition('home');
            }
          }
          if (data.event === 'toggle-struct-state') {
            let key = data['key'];
            let val = data['data'];
            this.khaConfig.struct_state_current[key] = val;
            this.khaConfig.applyDisplayRuleFor_Struct(key);
          }
          if (data.event === 'toggle-otherdecks-state') {
            let key = data['key'];
            let val = data['data'];
            this.khaConfig.otherDecks = val;
            this.khaConfig.applyDisplayRuleFor_OtherDecks();
          }
          if (data.event === 'toggle-bg') {
            let val = data['data'];
            this.khaConfig.changeBackgroundColor(val);
          }
          if (data.event === 'filter-deck') {
            // this.khaConfig.matTagClear();
            let val = data['data'];

            this.khaConfig.filter_deck = val;
            // this.khaConfig.filter_deck = val === '' ? null : val;
            // this.khaConfig.clearAllElements();
            this.khaConfig.applyDisplayRuleFor_Deck(true);
            // this.onChangeCameraPosition('home');
          }
          if (data.event === 'showhide-all-systems') {
            let val = data['data'];
            this.khaConfig.showHideSubSystemAll(val)
          }
          if (data.event == 'intensity') {
            this.setVenueLightIntensity(data.data);
          }
          if (data.event === 'reset-sub-systems') {
            this.khaConfig.resetSubSystems();
          }
          if (data.event === 'show-multiple-systems') {
            let khaList = data['data'];
            this.khaConfig.showHideMultipleSystems(khaList);
          }
          if (data.event === 'store-compartments') {
            let boo = data['data'];
            this.khaConfig.clear_compartments = !boo;
          }
          if (data.event === 'clearCompartment') {
            this.khaConfig.clearElements(data.data);
            this.khaConfig.clearCutOuts();
            this.khaConfig.clearPointer();
            this.khaConfig.clearSections();
            // setTimeout(() => {
            //   this.onChangeCameraPosition('home');
            // }, 500);
          }
          if (data.event === 'reset-views') {
            if (data['key']) {
              if (data['key'] === 'compartment') {
                this.selectedKha = "";
                this.khaConfig.selectedKha = "";
                this.khaConfig.resetSubSystems();
              } else if (data['key'] === 'system') {
                this.khaConfig.clearAllElements();
              }
            }
            setTimeout(() => {
              this.onChangeCameraPosition('home');
            }, 500);
          }
          if (data.event === 'updateSettigns') {
            var updateSettigns = data['data'];
            if (updateSettigns == true) {
              this.controlButton = false;
            } else {
              this.controlButton = true;
            }
          }
          if (data.event == 'groupList') {
            this.khaConfig.groupList = data.data;
          }
          if (data.event == "deleteGroup") {
            let deleteGroupData = data.data
            this.deleteGroup(deleteGroupData['_id']);
          }
          if (data.event == "createStatus") {
            this.btnStatus = 'Create';
            this.statusHeading = 'Create Status';
            this.statusWindow = true;
          }
          if (data.event == "statusDelete") {
            let deleteGroupData = data.data
            var deleteId = deleteGroupData.item
            this.statusId = deleteId['_id']
            this.deleteStatusData(this.statusId);
          }
          if (data.event == "deleteCompartments") {
            let sys = data.data
            if(this.selectedLayoutList){
              let layoutId = this.selectedLayoutList._id
              this.selectedLayoutList['tagPoints'].forEach(element => {
                if (element.code != undefined) {
                  if (element.code == sys.code) {
                    // this.deleteNotes(element.tagComments)
                    var selectedNotesId = element.id
                    var selectedNotesName = element.name
                    this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartmentNotes', data: selectedNotesId, key: layoutId, key1: selectedNotesName });
                  }
                }
              });
            }

            // var layoutId = this.selectedLayoutList._id
          }
        }
        if (data.src === "main") {
          if (data.event === 'updateMaterialStatus') {
            let obj = data['data'];
            if (obj) {
              this.updateMaterialServerData(obj);
            }
          }
          if (data.event === 'layoutNameSave') {
            //this.notesElement = data.data;
            this.showLayout = true;
          }
          if (data.event === 'closeLayoutScreen') {
            // console.log("793","reset")
            this.closeLayoutScreen();
          }
        }
        if (data.src === "gameServ") {
          if (data.event === 'onChangeCameraPosition') {
            let key = data['key'];
            if (key) {
              if (key === 'custom') {
                this.moveCameraTo(null, data['data']);
              } else {
                this.onChangeCameraPosition(key);
              }
            }
          }
        }
        if (data.src == "comment") {
          if (data.event == "create-comment") {
            this.khaConfig.matTagClear();
            if (this.pickedMeshObj) {
              this.pickedMeshObj.hit.x.toFixed(4)
              this.pickedMeshObj.hit.z.toFixed(4)
              this.pickedMeshObj.hit.y.toFixed(4)
            }
            this.pickedMeshObj['tagComments'] = data.data;
            this.selectedLayoutList['tagPoints'] = []
            this.selectedLayoutList['compartments'] = this.getActiveCompartments();
            this.selectedLayoutList['components'] = this.khaConfig.layoutComponents;
            if (this.selectedGropProps) {
              //this.pickedMeshObj['groupData'] = { name: this.selectedGropProps['name'], color: this.selectedGropProps['color'] }
            } else {
              //this.pickedMeshObj['groupData'] = { name: 'Group Name', color: '#fff' }
            }
            let mname = this.khaConfig.getMeshName(this.pickedMeshObj['partMeshId']);
            const found = this.khaConfig.storedMeshComps.some(el => el === mname);
            if (!found) {
              this.khaConfig.storedMeshComps.push(mname);
            }
            this.selectedLayoutList['markers'] = this.khaConfig.getCutMarkersData() || []
            this.selectedLayoutList['tagPoints'].push(this.pickedMeshObj);
            this.selectedTagItem = this.pickedMeshObj;
            this.updateLayout(this.selectedLayoutList['_id'], this.selectedLayoutList);
            this.khaConfig.getPartMesh(this.pickedMeshObj, (e) => {
              if (e) {
                this.khaConfig.createMatObjectPoint(this.pickedMeshObj, e);
                // this.khaConfig.updateAbsolutePosition(this.selectedLayoutList['tagPoints']);
              }
            });
          }
          if (data.event == "update-comment") {
            this.updateComment(data)
          }
          if (data.event == 'notesDelete') {
            console.log(data.data)
            this.deleteNotes(data.data)
          }
          if (data.event == 'temporary-comment') {
            this.temporaryCommentData = data['data']
          }
          if (data.event == 'commentsData') {
            var comments = data['data'];
            if (comments != undefined) {
              this.notesElement = comments;
              // this.notesElement['status'] = comments.status
              // this.notesElement["comments"] = comments.comments
              this.compComments = comments.comments;
            }
            // if (comments == true) {
            //   // this.getcommpartmentCommentDetails();
            //   // setTimeout(() => {
            //   // this.selectedNotes();
            //   // }, 1000);

            // }       
          }
        }
        if (data.src == "shipDetail") {
          if (data.event == 'groupColorUpdated') {
            if (this.selectedLayoutList) {
              if (this.layoutCloseDetailData.length == 0) {
                this.selectedLayoutList.tagPoints.forEach(obj => {
                  if (obj.groupId == data.data._id) {
                    obj.groupColor = data.data.color
                  }
                })
                this.khaConfig.groupColorChanges(this.selectedLayoutList);
              } else {
                this.layoutCloseDetailData.tagPoints.forEach(obj => {
                  if (obj.groupId == data.data._id) {
                    obj.groupColor = data.data.color
                  }
                })
                this.khaConfig.groupColorChanges(this.layoutCloseDetailData);
              }

              //this.processMutipleComparment(this.selectedLayoutList, true)
            }
            this.groupColorUpdated(data.data)
          }
        }
      })

    this.broadcastIframeSubs = this.CommunicationServ.getIframeInstance()
      .subscribe((data: any) => {
        if (data.iframeConnection === "init-nsc-connection") {
          if (data.event === 'onChangeNSCTree') {
            let obj = data.data;
            if (obj) {
              this.toggleSysComp(obj);
            }
          }
        }
      });

    // console.log("appMode",this.appMode);
  }
  //{code:"--",name:"_exterior",partId:"_exterior",status:true,result:1},{code:"--",name:"bulkheads_2L",partId:"bulkheads_2L",status:true,result:1},{code:"--",name:"bulkheads_2M",partId:"bulkheads_2M",status:true,result:1},{code:"--",name:"2DA",partId:"2DA",status:true,result:0}
  quizList: any = [
    { code: "--", name: "_exterior", partId: "_exterior", status: false, result: '' }, { code: "--", name: "bulkheads_2L", partId: "bulkheads_2L", status: false, result: '' }, { code: "--", name: "bulkheads_2M", partId: "bulkheads_2M", status: false, result: '' }, { code: "--", name: "2DA", partId: "2DA", status: false, result: '' }
  ];//[];
  getRandomQuizList() {
    setTimeout(() => {
      console.log(this.ctrlServ.shipComp['compList'])
      if (this.ctrlServ.shipComp['compList'].length > 0) {
        console.log("random", Math.floor(Math.random() * this.ctrlServ.shipComp['compList'].length), Math.floor(Math.random() * this.ctrlServ.shipComp['compList'].length), Math.floor(Math.random() * this.ctrlServ.shipComp['compList'].length), Math.floor(Math.random() * this.ctrlServ.shipComp['compList'].length));
        let quizList = [];
        // let list =new Array(5);
        // console.log("arr",new Array(5));
        for (let i = 0; quizList.length < 5; i++) {
          console.log("idx-start", i);
          let idx = Math.floor(Math.random() * this.ctrlServ.shipComp['compList'].length);
          let comp = this.ctrlServ.shipComp['compList'][idx];

          let deckQuiz = { code: "--", name: comp['code'], partId: comp['code'], status: false, result: '' };
          this.khaConfig.getPartMesh(deckQuiz, (e) => {
            console.log("startQuiz", deckQuiz['code'], e);
            var mesh: any = e;
            if (mesh) {
              deckQuiz['mesh'] = mesh;
              if (deckQuiz['partId'].substring(0, 1).toLowerCase() == '6' || deckQuiz['partId'].substring(0, 1).toLowerCase() == 'z' || deckQuiz['partId'].substring(0, 1).toLowerCase() == 'm') {

              } else {
                quizList.push(deckQuiz);
              }
            }
            // i+1;

            console.log("idx-mesh", i);
          })
          console.log("idx-end", i);
          // var mesh:any = this.startQuiz(deckQuiz);

        }
        this.quizList = quizList;
        // this.startQuiz()
      }
      console.log("quizOrderList", this.quizList, this.quizOrder);
      this.quizOrderList();
    }, 1500)
  }
  quizOrder: any = 1;
  startQuiz(ele) {
    // setTimeout(() => {
    // this.quizList.forEach((ele,i)=>{
    var mesh;
    console.log("startQuiz", ele['code']);
    this.khaConfig.getPartMesh(ele, (e) => {
      console.log("startQuiz", ele['code'], e);
      mesh = e;
    })
    // })
    // console.log("startQuiz",this.quizList); 

    // },1000);

  }
  quizOrderList() {
    setTimeout(() => {
      // this.getRandomQuizList();
      console.log("quizOrderList", this.quizList, this.quizOrder);
      let idx = this.quizOrder - 1;
      let code = this.quizList[idx]['code'] == "--" ? this.quizList[idx]['partId'] : this.quizList[idx]['code'];
      this.broadcastInfo({ src: 'material', event: 'selectedDeckQuiz', data: this.quizList[idx], key: "" });
      this.selectedMesh = this.quizList[idx]['mesh'];
      this.getSelectedKhaSystemsLabel(this.quizList[idx]['mesh'], [code]);
      this.khaConfig.focusStaticElement(this.quizList[idx]);
      this.broadcastInfo({ src: 'material', event: 'deckToggle', state: false, key: "" });
      this.quizPanel = true;

    }, 500);

  }

  // createtagPoints(){
  //   this.khaConfig.createMatObjectPoint();
  // }
  updateMaterialServerData(data) {
    this.getMaterialStatusData(() => {
      if (!this.showBlockLoading) {
        this.khaConfig.getSystemCompStatus((boo) => {
          if (boo === true && this.statusMode === true && this.khaConfig.khasystem === data['khasystem']) {
            this.broadcastInfo({ src: 'material', event: 'change-material-status', data: '', sub: null });
          }
        })
      }
    });
  }

  loadShipImg() {
    if (this.selectedKha != '') {
      if (this.selectedKha) {
        let area = this.selectedKha.split(" ").join("").toLowerCase();
        if (area === 'firesafety') {
          this.imgSrc = '../../assets/images/fire.png';
        } else if (area === 'buoyancy') {
          this.imgSrc = '../../assets/images/buoyancy.png';
        } else if (area === 'eer') {
          this.imgSrc = '../../assets/images/eer.png';
        } else {
          this.imgSrc = '';
        }
      }
    }
  }

  getBGLabel(state) {
    let idx = this.statusList.findIndex(e => e.status == state);
    if (idx > -1) {
      return this.statusList[idx].color;
    }
  }

  ngAfterViewInit(): void {
    this.configService.loadFile('../assets/license.info').then((info) => {
      this.configService.getProjectConfig().then((project_config: any) => {
        project_config.licence = info;
        this.datauxview.setProjectSettins(project_config);
        this.datauxview.loadCanvas('settings-systems', 'json', (data, settingstatus) => {
          this.initShipObjects();

        }, (err) => { console.log(err) });
      }, (err) => { alert("License not found!") })

    })

  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (!this.dfx) {
      return
    }
    if (event.target.innerWidth < 1024) {
      this.dfx.moveCamera({ distance: 200 });
    } else {
      this.dfx.moveCamera({ distance: 90 });
    }
  }

  /* * * * *
  * init objects
  * loading all the static objects from objects.json
  * * * * * */
  initObjects(cbck) {
    this.datauxview.loadAssets('objects-systems', 'json', (objectstatus) => {
      if (objectstatus) {
        this.datauxview.renderAssets('objects-systems', 'json', (objectstatus) => {
          if (objectstatus) {
            this.dfx = this.datauxview.getDatascape();
            if (window.innerWidth < 1024) {
              this.datauxview.getDatascape().moveCamera({ distance: 200 });
            }
            this.ctrlServ.init(this.datauxview);
            cbck();
          }
        }, () => { })
      }
    });
  }

  /* * * * *
  * init game service 
  * * * * * */
  initGameMode(data) {
    this.gameManager = new GameService(this.datauxview, this.CommunicationServ, this.khaConfig);
    this.gameManager.getTask(data['data'] || 'tour');
    this.gameManager.initGameMode(data);

  }

  /* * * * *
  * init dynamic ship objects
  * loading all the dynamic objects from objects.json
  * * * * * */

  initShipObjects() {
    this.initObjects(() => {
      if (this.mvScreenType == 'system') {
        this.loadShipObjects((boo) => {
          this.getMaterialStatusData(() => {
            this.initView()
          })
        })
      }
      if (this.mvScreenType == "compartment") {
        if (this.slms_mode) {
          this.loadShipObjects((boo) => {
            this.initView()
          }, this.ship_settings_slms)
        } else {
          this.initView()
        }
      }
    })
  }
  // deleteData() {
  //   ["62061d08a374eb0036e4184f", "62061d10a374eb0036e41851", "62061d19a374eb0036e41852", "620d594d28bd4400355214e1", "620d5a0128bd4400355214e2"].forEach(e => {
  //     this.deleteGroup(e)
  //   })
  //   // ["620c8cc428bd4400355214de"].forEach(e=>{
  //   //   this.deleteLayout(e)
  //   // })

  // }
  initView() {
    this.getStatusData();
    this.getGroupData();
    // this.deleteData();

    this.getLayoutData();
    this.getcommpartmentCommentDetails();
    this.setVenueLightIntensity();
    this.initSystemsModel();
    this.khaConfig.hideExitRoutes();
    this.removeLoader();

    this.initialized = true;
    this.isMaterialAppLoaded = true;
    this.ctrlServ.isMaterialAppLoaded = true;
    this.showBlockLoading = false;
    this.showLoading = false;
    this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
    if (this.appMode == "kys-quiz-mode"||this.appMode == "kys") {
      // this.startQuiz();
      setTimeout(() => {
        this.khaConfig.appMode = this.appMode;
        if (this.appMode == "kys-quiz-mode") {
          this.broadcastInfo({ src: 'sidepanel', event: 'showhide-deck-labels', key: true, data: '' });
          this.getRandomQuizList();
        }
        this.broadcastInfo({ src: 'material', event: 'quiz-sidepanel-hide', key: true, data: this.appMode });
      }, 1000);
    }
    if (this.testMode.includes("game-mode")) {
      setTimeout(() => {
        let data = 'tour';
        let gameid = 1;
        if (this.testMode === 'game-mode-2') {
          data = 'demo2'
        }
        if (this.testMode === 'game-mode-3') {
          data = 'demo2'
          gameid = 2;
        }
        this.initGameMode({ data, gameid });
        this.broadcastInfo({ src: 'sidepanel', event: 'updateSettigns', data: true });
      }, 500)
    } else {
      this.khaConfig.initCutOff();
      /**
       * remove camera lower limit
       * TODO - in dataux library, 
       *      - add option to change the camera limits
       */
      this.dfx.getCamera().pitch_deg.lowerLimit = null;
    }
  }

  /* * *
  * method for remove loader
  * * */
  removeLoader() {
    let ldiv = document.getElementById("babylonjsLoadingDiv");
    if (ldiv) {
      ldiv.remove();
    }
  }

  /* * *
  * load dynamic ship settings and objects
  * * */

  loadShipObjects(cbck = null, settings = null) {
    this.dfx.addDynamicShapes(settings || this.ship_settings).then(() => {
      let shapes = this.ship_objects['shapes'];
      let objects = this.ship_objects['objects'];
      this.datauxview._createModels(shapes, (boo) => {
        this.datauxview.addElements(objects, (portObjects) => {
          if (cbck) {
            this.allShipElements = portObjects;
            this.ctrlServ.hideElement("ernhfx");
            let ernhfx = this.ctrlServ.getMesh("ernhfx");
            ernhfx.rotationQuaternion = null;
            cbck(true);
          }
        }, (id, pointer) => { })
      }, (id, pointer) => { })
    });
  }

  /**
   * init system model
   */
  initSystemsModel() {
    window['sys_scope'] = this;
    this.khaConfig.scene = this.scene;
    this.khaConfig.game_engine = this.scene.getEngine();
    this.khaConfig.dfx = this.dfx;
    this.khaConfig.datauxview = this.datauxview;
    if (this.mvScreenType == 'system') {
      this.processHFX();
      if (this.selectedKha) {
        let sys = this.selectedKha.split(" ").join("").toLowerCase();
        this.khaConfig.initSystems(sys);
      }
    }
    if (this.mvScreenType == "compartment") {
      if (this.slms_mode) {
        this.processHFX_slms();
        this.khaConfig.slms_mode = this.slms_mode;
        let ehfx = this.datauxview.getElementId('ehfx');
        let hfx = this.dfx.getElementMesh(ehfx)
        this.khaConfig.khasystemship = hfx.getChildren()[0];
        this.khaConfig.getSysDefalutPosition(this.khaConfig.khasystemship);
        this.khaConfig.applyDisplayRule_Struct(false, this.khaConfig.struct_state_slms_1);
        this.khaConfig.applyDisplayRuleFor_Deck();
      }
      this.khaConfig.processandloadComparment();
    }
  }

  processHFX_slms() {
    let ehfx = this.datauxview.getElementId("ehfx");
    let hfx = this.dfx.getElementMesh(ehfx);
    hfx.scaling.z = -1;
    this.processShipMaterial();

    hfx.getChildren()[0].getChildMeshes().forEach((mesh) => {
      let mat = mesh.material ? mesh.material.name : "";
      mesh.mid = mat;
    })
  }

  processHFX() {
    let ehfx = this.datauxview.getElementId("ehfx");
    let hfx = this.dfx.getElementMesh(ehfx);
    hfx.scaling.z = -1;
    hfx.getChildren()[0].setEnabled(false);
    let scene = this.scene;
    this.processShipMaterial();
    hfx.getChildren()[1].getChildMeshes().forEach((mesh) => {
      let mat = mesh.material ? mesh.material.name : "";
      mesh.mid = mat;
    })
  }

  processShipMaterial() {
    this.scene.materials.forEach((mat) => {
      if (mat.getClassName().includes("PBR")) {
        mat.specularIntensity = 0;
        mat.metallic = 0;
        mat.roughness = 1;
        mat.ambientColor = this.dfx.color3([1, 1, 1]);
      }
    })
  }

  cancelSystemLoading() {
    this.khaConfig.cancelSystemLoading()
  }


  dragChange(e) {
    this.canvasDragChange = e;
  }

  ngOnDestroy() {
    this.broadcastSubs.unsubscribe()
    this.khaConfig.destroy();
    let dfx = this.dfx;
    dfx.stop();
    dfx.dispose();
  }

  getClassImg(shipClass) {
    return shipClass == 'Halifax' ? 'HAL' : shipClass == 'Dewolf' ? 'HDW' : shipClass == 'Kingston' ? 'KIN' : shipClass == 'Victoria' ? 'VIC' : shipClass == 'Orca' ? 'ORC' : shipClass == 'Asterix' ? 'AST' : shipClass == 'Protecteur' ? 'PRT' : shipClass == 'CSC' ? 'csc' : '';
  }

  infoToggleOpenHandle() {
    this.broadcastInfo({ src: 'networkmodel', event: 'sidepanel', state: null, sub: null });
  }

  toggleSysComp(data) {
    if (this.selectedKha === data['kha']) {
      if (data['comp']) {
        let comp = data['comp'].split(",");
        this.ctrlServ.selectedSysComp = comp;
        this.ctrlServ.showSysComp = comp;
        this.khaConfig.showHideSubSystem(this.ctrlServ.selectedSysComp, true, true);
      }
    } else {
      let comp = data['comp'].split(",");
      this.ctrlServ.selectedSysComp = comp;
      this.ctrlServ.showSysComp = comp;
      this.broadcastInfo({ src: 'material', event: 'onChangeKHASystem', data: data['kha'], comp: comp });
    }
  }

  loadERNTree() {
    this.overlayHeading = "NSSC";
    this.ernOverlayMode = true;
    this.loadUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(window.origin + "/?screenType=ern");
  }

  onLoadERNTree(data) {
    this.overlayHeading = "NSSC";
    this.ernOverlayMode = true;
    let ernCategory = data['data'];
    let ernNumber = data['ern']
    this.loadUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(window.origin + "/?screenType=ern_kha&erncategory=" + ernCategory + "&ernnumber=" + ernNumber);
  }

  onLoadNSCTree(data) {
    let selectedKha = data['data'];
    if (selectedKha) {
      this.broadcastIframeInfo({ iframeConnection: 'init-nsc-connection', event: 'onChangeNSCTree', data: selectedKha, key: "" });
    }
  }

  onCloseOverlay() {
    this.ernOverlayMode = !true;
  }

  /**
   * utility functions
   */
  private componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  rgbToHex(r, g, b) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  openStatusWindow() {
    if (this.statusMode) {
      if (this.selectedKhaSystems['desc'] === this.ctrlServ.selectedSysComments['name']) {
        this.statusMessage = this.ctrlServ.selectedSysComments['message'];
        this.statusChange = true;
      } else {
        this.statusMessage = '';
        this.statusChange = false;
      }
      let kha = { "buoyancy": "Buoyancy", "firesafety": "Fire Safety", "eer": "EER" }
      this.khasystem_name = kha[this.khaConfig.khasystem];
      this.materialStatusWindow = !this.materialStatusWindow;
    }
  }

  statusWindowClose() {
    this.statusChange = false;
    this.materialStatusWindow = false;
  }

  onChangeStatus(status) {
    if (this.selectedStatus != status) {
      this.selectedStatus = status;
      this.statusChange = true;
    } else {
      this.statusChange = false;
    }
  }

  onMessage(e) {
    if (this.statusMessage) {
      this.statusChange = true;
    } else {
      this.statusChange = false;
    }
  }

  /* * *
  * method for get material status data from server
  * * */
  getMaterialStatusData(cbck) {
    this.khaConfig.MaterialStatusData = [];
    this.configService.getMaterialStatusData().then((data: any) => {
      if (data) {
        this.khaConfig.MaterialStatusData = data;
        console.log("MaterialStatusData ", this.khaConfig.MaterialStatusData);
        cbck()
      } else {
        console.log('MaterialStatusData data not found !!');
        cbck()
      }
    }).catch((error) => {
      console.log("error ", error);
      cbck();
    });
  }

  addEditMaterialStatus(id, material) {
    const item = this.khaConfig.MaterialStatusData.find(el => el['name'] === id && el['khasystem'] === this.khaConfig.khasystem);
    if (item) {
      let obj = { "name": id, "material": material, "khasystem": this.khaConfig.khasystem };
      this.configService.updateMaterialStatus(item['_id'], obj).then(data => {
        if (data) {
          obj['_id'] = item['_id'];
          console.log("material status updated ", [obj]);
          this.updateMaterialStatusData([obj]);
          let message = encodeURIComponent(this.statusMessage);
          let link = window.origin + '/?screenType=materiel_kha&KHA=' + this.khaConfig.khasystem + '&comp_name=' + this.selectedKhaSystems['desc'] + '&message=' + message;
          let _obj = Object.assign({}, this.selectedKhaSystems, { 'type': "material-status-change", 'message': this.statusMessage, 'link': link, 'material': this.selectedStatus, "khasystem": this.khaConfig.khasystem, "khasysname": this.khasystem_name })
          this.broadcastInfo({ src: 'material', event: 'pushNotification', data: _obj, sub: null });
        }
      }).catch((error) => {
        console.log("error ", error)
      });
    } else {
      let obj = { "name": id, "material": material, "khasystem": this.khaConfig.khasystem };
      this.configService.createMaterialStatus(obj).then(data => {
        if (data) {
          console.log("material status created ", data);
          this.updateMaterialStatusData(data['ops']);
          let message = encodeURIComponent(this.statusMessage);
          let link = window.origin + '/?screenType=materiel_kha&KHA=' + this.khaConfig.khasystem + '&comp_name=' + this.selectedKhaSystems['desc'] + '&message=' + message;
          let obj = Object.assign({}, this.selectedKhaSystems, { 'type': "material-status-change", 'message': this.statusMessage, 'link': link, 'material': this.selectedStatus, "khasystem": this.khaConfig.khasystem, "khasysname": this.khasystem_name })
          this.broadcastInfo({ src: 'material', event: 'pushNotification', data: obj, sub: null });
        }
      }).catch((error) => {
        console.log("error ", error)
      });
    }
  }

  updateMaterialStatusData(data) {
    data.forEach(mat => {
      const idx = this.khaConfig.MaterialStatusData.findIndex(el => el._id === mat._id);
      if (idx > -1) {
        this.khaConfig.MaterialStatusData[idx]['name'] = mat['name'];
        this.khaConfig.MaterialStatusData[idx]['material'] = mat['material'];
        this.khaConfig.MaterialStatusData[idx]['khasystem'] = mat['khasystem'];
      } else {
        this.khaConfig.MaterialStatusData.push(mat);
      }
    });
  }

  updateMaterialStatus() {
    let colors = { "red": "#ff0000", "yellow": "#ffff00", "transparent": "#ababb2" };
    let mat = this.getStatusColorCode(this.selectedKhaSystems.id);
    if (mat && this.selectedStatus) {
      let subSystems = this.khaConfig.systemSubComps[mat];
      if (subSystems.length > 0) {
        const idx = subSystems.findIndex(m => m.id === this.selectedKhaSystems.id);
        if (idx > -1) {
          let item = subSystems[idx];
          this.khaConfig.systemSubComps[this.selectedStatus].push(item);
          subSystems.splice(idx, 1);
          this.selectedKhaSystems.color = colors[this.selectedStatus];
          this.khaConfig.systemSubComps[mat] = subSystems;
          this.khaConfig.updateSystemStatus(item, this.selectedStatus);
          this.statusWindowClose();
          this.addEditMaterialStatus(this.selectedKhaSystems.id, this.selectedStatus);
        }
      }
    }
  }
  selectedTagItem: any;
  selectedGropProps: any;
  openCommentWindow(tagList, groupProps) {
    this.selectedGropProps = groupProps;
    if (tagList) {
      this.selectedKhaSystems = { code: tagList.code, color: '#000', id: tagList.meshId, desc: tagList.name };
    }
    // if (this.selectedKhaSystems['desc'] === this.ctrlServ.selectedCompComments['name']) {
    //   this.compComments = this.ctrlServ.selectedCompComments['message'];
    //   this.isCommentTyped = true;
    // } else {
    //   this.compComments = '';
    //   this.isCommentTyped = false;
    // }
    this.selectedTagItem = tagList;
    console.log(this.selectedLayoutList, this.selectedTagItem);
    this.compCommentWindow = true;
    setTimeout(() => {
      this.broadcastInfo({ src: 'kys', event: 'statusData', data: this.statusListData });
    }, 100);
  }

  commentWindowClose() {
    this.compCommentWindow = false;
  }
  selectedGroupData: any;
  selectedGroup() {
    delete this.selectedGroupData;
    if (this.groupList.length > 0) {
      this.groupList.forEach((element, i) => {
        if (element['groupList'].length > 0) {
          let idx = element['groupList'].findIndex(e => e.id == this.selectedKhaSystems.id);
          if (idx > -1) {
            this.selectedGroupData = this.groupList[i];
            let color = this.selectedGroupData['color'] || null;
            let mname = this.ctrlServ.getMeshName(this.selectedKhaSystems.id);
            let floorColor = this.khaConfig.checkDeckFloor(mname);
            this.khaConfig.highlightSelection(this.selectedMesh, 4, color, true, floorColor);
          }
        }
      })
    }
  }
  selectedLayoutData: any;
  selectedLayout() {
    delete this.selectedLayoutData;
    delete this.selectedLayoutName;
    // console.log("selectedLayout",this.selectedLayoutData);
    var meshName = this.khaConfig.getMeshName(this.selectedKhaSystems.id)
    if (this.layoutData.length > 0) {
      this.layoutData.forEach((element, i) => {
        if (element['components'].length > 0) {
          let idx = element['components'].findIndex(e => e.name == meshName);
          if (idx > -1) {
            this.selectedLayoutData = this.layoutData[i];
            // console.log("selectedGroup",this.selectedLayoutData);
          }
        }
      })
    }
  }
  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  rgba2hex(color) {
    const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',');
    const hex = `#${((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1)}`;

    return hex;
  }
  componentFromStr(numStr, percent) {
    var num = Math.max(0, parseInt(numStr, 10));
    return percent ?
      Math.floor(255 * Math.min(100, num) / 100) : Math.min(255, num);
  }
  rgb2hex(rgb) {
    var rgbRegex = /^rgb\(\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*,\s*(-?\d+)(%?)\s*\)$/;
    var result, r, g, b, hex = "";
    if ((result = rgbRegex.exec(rgb))) {
      r = this.componentFromStr(result[1], result[2]);
      g = this.componentFromStr(result[3], result[4]);
      b = this.componentFromStr(result[5], result[6]);

      hex = "0x" + (0x1000000 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    return hex;
  }
  editGroupData: any;
  openGroupPanel(e, data = undefined) {
    this.groupState = e;
    if (this.groupState == 'edit') {
      this.editGroupData = data;
      this.groupName = data.name;
      this.groupStatusColor = data.color.indexOf('rgba(') > -1 ? this.rgba2hex(data.color) : data.color.indexOf('rgb(') > -1 ? this.rgb2hex(data.color) : data.color;
    } else {
      if (this.selectedKhaSystems && this.shipCompartment) {
        this.groupData = Object.assign(this.selectedKhaSystems, this.shipCompartment);
        console.log("groupData", this.groupData);
      }
      this.groupStatusColor = this.getRandomColor();
    }

    this.groupWindow = true;
  }

  groupWindowClose() {
    this.groupWindow = false;
    delete this.editGroupData;
    delete this.groupName, this.groupState, this.groupData;

  }
  getUID() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return Math.random().toString(36).substr(2, 9);
  }
  // removeGroupCompoments() {
  //   var groupData = Object.assign(this.selectedKhaSystems, this.shipCompartment);
  //   this.checkGroup(groupData, true)
  // }

  // checkGroup(groupData, state = false) {
  //   if (this.groupList.length > 0) {
  //     this.groupList.forEach((element, i) => {
  //       if (element['groupList'].length > 0) {
  //         let idx = element['groupList'].findIndex(e => e.id == groupData.id);
  //         if (idx > -1) {
  //           var clrCompdata = this.groupList[i]['groupList'][idx];
  //           this.groupList[i]['groupList'].splice(idx, 1);
  //           console.log("checkGroup", this.groupList[i]);
  //           let inx = this.groupList[i]['groupList'].findIndex(e => e.code == clrCompdata.code);
  //           // if(inx==-1){
  //           //   this.khaConfig.clearElements(clrCompdata.code);
  //           //   this.khaConfig.matTagClear();
  //           //   this.onChangeCameraPosition('home')
  //           // }
  //           this.updateGroup(this.groupList[i], (obj) => {
  //             if (state) {
  //               setTimeout(() => {
  //                 this.broadcastInfo({ src: 'material', event: 'updateLoadGroup', data: this.selectedKhaSystems });
  //               }, 2000);
  //             }
  //             // this.broadcastInfo({ src: 'material', event: 'updateLoadGroup', data:this.selectedKhaSystems });
  //           });
  //         }
  //       }
  //     })
  //   }
  //   this.selectedGroup();
  // }

  // selectGroup(ele, tagList = undefined) {
  //   // this.groupName=ele.name;

  //   let systemProps = {};
  //   if (tagList) {
  //     systemProps = tagList;
  //     this.selectedKhaSystems = { code: tagList.code, color: '#000', id: tagList.partMeshId, desc: tagList.name };
  //   } else {
  //     if(this.pickedMeshObj) {
  //       console.log(this.pickedMeshObj)
  //       console.log(this.selectedLayoutList)
  //       this.pickedMeshObj['groupData'] ={'color' : ele.color, "name": ele.name}
  //       this.pickedMeshObj['tagComments'] = []
  //       if(this.selectedLayoutList){
  //         this.selectedLayoutList['tagPoints'] = []
  //         this.selectedLayoutList['tagPoints'].push(this.pickedMeshObj)
  //       }
  //       this.pickedMeshObj['markers'] = this.khaConfig.getCutMarkersData();
  //       if(!this.layoutHeading){
  //         this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutName' , data: this.temporaryCommentData});
  //       } else {
  //         if(this.selectedLayoutList){
  //           this.onSaveLayout()
  //         }
  //       }
  //     }
  //     systemProps = { code: this.selectedKhaSystems.code, partMeshId: this.selectedMesh.name }
  //   }
  //   this.groupData = Object.assign(this.selectedKhaSystems, this.shipCompartment);
  //   let update = false;
  //   this.checkGroup(this.groupData)
  //   let idx = this.groupList.findIndex(e => e._id == ele._id);
  //   if (idx > -1) {

  //     if (this.groupList[idx]['groupList'].length > 0) {

  //       let indx = this.groupList[idx]['groupList'].findIndex(e => e.id == this.groupData.id);
  //       if (indx == -1) {
  //         this.groupList[idx]['groupList'].push(this.groupData);
  //         update = true;
  //       } else {
  //         console.log("this part already in this group");
  //         update = false;
  //       }
  //     } else {
  //       this.groupList[idx]['groupList'].push(this.groupData);
  //       update = true;
  //     }

  //     if (update) {
  //       this.khaConfig.updateMatObjectPoint(systemProps, this.groupList[idx]);
  //       let id = this.groupList[idx]['_id'];
  //       this.updateGroup(this.groupList[idx], (obj) => {
  //         // this.broadcastInfo({ src: 'sidepanel', event: 'groupList', data: this.groupList[idx]['groupList'], key: "" });
  //         setTimeout(() => {
  //           this.broadcastInfo({ src: 'material', event: 'updateLoadGroup', data: this.selectedKhaSystems });
  //           this.khaConfig.updateMatObjectPoint(systemProps, this.groupList[idx]);
  //         }, 2000);
  //       });
  //       // this.broadcastInfo({ src: 'kys', event: 'updateGroup', data:this.groupList });
  //     }
  //   }
  //   if (this.selectedKhaSystems) {
  //     this.selectedGroup()
  //     this.selectedNotes()
  //   }
  // }
  groupStatusColor: any = "#f5f5f5"
  onSaveGroup() {
    console.log(this.groupName, this.groupData);
    if (this.groupState == 'new') {
      // let uId=this.getUID();
      // var id ="gp"+uId;
      var data = { "name": "", "groupList": [], "color": "" };
      // data['group_id'] = id;
      data['name'] = this.groupName;
      data['color'] = this.groupStatusColor;
      const found = this.groupList.some(el => el.name.split(" ").join("").toLowerCase() === this.groupName.split(" ").join("").toLowerCase());
      // data['groupList'].push(this.groupData);
      // this.groupList.push(data);
      // this.broadcastInfo({ src: 'kys', event: 'createGroup', data:this.groupList });
      if (!found) {
        this.createGroup(data, (obj) => {
          console.log('createGroup-id', obj);
          // setTimeout(() => {
          //   let idx = this.groupList.findIndex(e => e['_id'] == obj['insertedId']);
          //   console.log('createGroup-id', obj, idx);
          //   if (idx > -1) {
          //     this.selectGroup(this.groupList[idx])
          //   }
          // }, 1000);

        });
      } else {
        this.groupData = '';
        this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Group name already exists !!" });
        this.groupWindow = true;
      }

    } else if (this.groupState == 'edit') {
      let idx = this.groupList.findIndex(e => e._id == this.editGroupData['_id']);
      if (idx > -1) {
        this.groupList[idx]['name'] = this.groupName;
        this.groupList[idx]['color'] = this.groupStatusColor;
        console.log("edit", this.groupList[idx]);
        this.updateGroup(this.groupList[idx], (obj) => {
          // delete this.editGroupData;
        })
      }
      delete this.editGroupData;
    }
    // else if(this.groupState=='existing'){
    //   let idx = this.groupList.findIndex(e=> e.group_id==this.groupName.group_id);
    //   if(idx>-1){
    //     if(this.groupList[idx]['groupList'].length>0){
    //       let indx = this.groupList[idx]['groupList'].findIndex(e=> e.id==this.groupData.id);
    //       if(indx==-1){
    //         this.groupList[idx]['groupList'].push(this.groupData)
    //       }else{
    //         console.log("this part already in this group" )
    //       }
    //     }else{
    //       this.groupList[idx]['groupList'].push(this.groupData)
    //     }        
    //   }
    //   // data['groupList']=this.groupData;
    //   // this.groupList.push(data);
    // }

    this.groupWindow = false;
    delete this.groupName;
    delete this.groupState
    delete this.groupData;
    console.log(this.groupName, this.groupData, this.groupList);
  }
  /* * *
  * group code start
  * * */
  getGroupData() {
    this.configService.getGroupListData().then((response: any) => {
      console.log("getCreateData ", response);
      this.groupList = response;
      this.broadcastInfo({ src: 'kys', event: 'updateGroup', data: this.groupList });
      // this.selectedGroup();
      this.getGroupItem();
      // cbck(response)

    }).catch((error) => {
      // console.log("error ", error);
      // cbck(error)
    });
  }

  createGroup(data, cbck) {
    this.configService.createGroup(data).then(data => {
      if (data) {
        console.log("groupCreated ", data);
        this.getGroupData();
        cbck(data)
      }
    }).catch((error) => {
      // console.log("error ", error);
      cbck(error)
    });
  }

  updateGroup(data, cbck) {
    console.log("update", data);
    if (data) {
      this.configService.updateGroup(data._id, data).then(data => {
        if (data) {
          console.log("group updated ", data);
          this.getGroupData();
          cbck(data)
        }
      }).catch((error) => {
        // console.log("error ", error);
        cbck(error)
      });
    }

  }
  deleteGroup(_id) {
    this.configService.deleteGroup(_id).then(data => {
      if (data) {
        console.log("group deleted ", data);
        this.getGroupData();
      }
    }).catch((error) => {
      // console.log("error ", error);
    });
  }
  getGroupItem() {
    // console.log("getGroupItem");
    if (this.layoutData.length > 0) {
      this.layoutData.forEach((layoutParent, layoutIdx) => {
        if (layoutParent['tagPoints'].length > 0) {
          layoutParent['tagPoints'].forEach((layout, layIdx) => {
            var dataState = false;
            if (this.groupList != undefined) {
              if (this.groupList.length > 0) {
                if (layout.groupId) {
                  let idx = this.groupList.findIndex(el => el['_id'].includes(layout.groupId));
                  if (idx > -1) {
                    this.layoutData[layoutIdx]['tagPoints'][layIdx]['groupData'] = this.groupList[idx];
                    dataState = true;
                  } else {
                    if (!dataState) {
                      this.layoutData[layoutIdx]['tagPoints'][layIdx]['groupData'] = { 'name': 'Group Name', 'color': '#fff' };
                    }
                  }
                } else {
                  this.layoutData[layoutIdx]['tagPoints'][layIdx]['groupData'] = { 'name': 'Group Name', 'color': '#fff' };
                }

              }
            }

          });
          // this.broadcastInfo({ src: 'material', event: 'layoutTagGroup', data: this.selectedLayoutList });

        }
      });
      this.broadcastInfo({ src: 'material', event: 'updateLayoutData', data: this.layoutData, sub: null });

      if (this.selectedLayoutList) {
        if (this.selectedLayoutList['tagPoints'].length > 0) {
          this.selectedLayoutList['tagPoints'].forEach((layout, layIdx) => {
            var dataState = false;
            if (this.groupList != undefined) {
              if (this.groupList.length > 0) {
                // this.groupList.forEach((element, i) => {
                //   if (element['groupList'].length > 0) {
                if (layout.groupId) {
                  let idx = this.groupList.findIndex(el => el['_id'].includes(layout.groupId));
                  // console.log("getGroupItem", idx, this.groupList[i], layout.partId)
                  if (idx > -1) {
                    this.selectedLayoutList['tagPoints'][layIdx]['groupData'] = this.groupList[idx];
                    dataState = true;
                  } else {
                    if (!dataState) {
                      this.selectedLayoutList['tagPoints'][layIdx]['groupData'] = { 'name': 'Group Name', 'color': '#fff' };
                    }
                  }
                } else {
                  this.selectedLayoutList['tagPoints'][layIdx]['groupData'] = { 'name': 'Group Name', 'color': '#fff' };
                }
                //   }
                // })
              }
            }
          });
          this.broadcastInfo({ src: 'material', event: 'layoutTagGroup', data: this.selectedLayoutList });
        }
      }
    }
  }
  onComment(e) {
    if (this.compComments) {
      this.isCommentTyped = true;
    } else {
      this.isCommentTyped = false;
    }
  }

  onSaveComment() {
    this.commentWindowClose();
    let message = encodeURIComponent(this.compComments);
    let link = window.origin + '/?screenType=materiel_comp&comp_code=' + this.shipCompartment['code'] + '&comp_name=' + this.selectedKhaSystems['desc'] + '&message=' + message;
    let obj = Object.assign({}, this.selectedKhaSystems, { 'type': "compartment-comments", 'message': this.compComments, 'link': link })
    this.broadcastInfo({ src: 'material', event: 'pushNotification', data: obj, sub: null });
  }

  /**
   * 
   */
  initPathAnim() {
    let engine = this.ctrlServ.getMesh('ehfx_path_1');
    let scene = this.scene;
    scene.stopAllAnimations();
    let ag = scene.animationGroups;
    ag.forEach((g) => {
      let norm = false;
      g.targetedAnimations.forEach((a) => {
        let n = a.target.name
        let nt = this.ctrlServ.getChildMeshEx('ehfx_path_1', n);
        a.target = nt;
      })
      g.reset();
      g.onAnimationEndObservable.add((e) => {
        if (e.animation.targetProperty === 'position') {
          let avt = this.ctrlServ.getChildMeshEx('ehfx_path_1', 'avatar');
          let cam = this.dfx.getCamera();
          let apos = avt.position;
          cam.targetX.value = apos.x;
          cam.targetY.value = apos.y;
          cam.targetZ.value = apos.z;
          cam.distance.value = 0.1;
          cam.yaw_deg.value = avt.rotationQuaternion.toEulerAngles().y * 180 / Math.PI;
          this.dfx.detachCameraFromTarget();
        }

      })
    })
    engine.scaling.z *= -1;
  }

  // showLoader(boo) {
  //   this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: boo, process_txt: "Processing...", selectedDemo: this.pcsDemos[0] || "", event: 'showBlockLoading' } });
  // }
  getLayoutCompartment() {
    this.layoutData.forEach((e, i) => {
      this.layoutData[i]['compartments'] = this.khaConfig.getLayoutCompartment(e);
    })

  }
  /* * *
   * Layout code start
   * * */
  getLayoutData(createNew = false) {
    this.configService.getLayoutData().then((response: any) => {
      console.log("getLayoutData ", response);

      this.layoutData = response;
      this.getLayoutCompartment();

      setTimeout(() => {
        if (this.selectedLayoutList) {
          var filterLayout = this.layoutData.filter(e => e._id == this.selectedLayoutList._id)
          if (filterLayout.length > 0) {
            // this.khaConfig.processMutipleComparment(filterLayout[0], false);
            this.selectedLayoutList = filterLayout[0];
            this.khaConfig.layoutData = filterLayout[0];
          }
        }

        if (response) {
          this.broadcastInfo({ src: 'material', event: 'updateLayoutData', data: this.layoutData, sub: null });
        }
        this.getGroupItem();
        this.khaConfig.last_cselect = null;
        this.khaConfig.selectedMarker = null;
        if (createNew) {
          const idx = this.layoutData.findIndex(el => el.layoutName.split(" ").join("").toLowerCase() === this.layoutName.split(" ").join("").toLowerCase());
          if (idx > -1) {
            this.khaConfig.layoutData = this.layoutData[idx];
            if (this.pickedMeshObj && this.pickedMeshObj['groupId']) {
              let inx = this.groupList.findIndex(e => e['_id'] == this.pickedMeshObj['groupId']);
              if (inx > -1) {
                this.khaConfig.updateMatObjectPoint(this.pickedMeshObj, this.groupList[inx]);
                if (this.layoutData[idx]['tagpoints'] && this.layoutData[idx]['tagpoints'].length > 0) {
                  let tagIdx = this.layoutData[idx]['tagpoints'].findIndex(e => e.id == this.pickedMeshObj['id']);
                  if (tagIdx > -1) {
                    this.broadcastInfo({ src: 'khaservice', event: 'updateActiveCard', data: tagIdx });
                  }
                }
                // if(this.khaConfig.current_marker.length>0){
                //   let markers = this.khaConfig.current_marker;
                //   this.khaConfig.applyCutMarkersFromData(markers);
                //   this.khaConfig.current_marker=[];
                // }

                delete this.pickedMeshObj;
              }
            }
            this.broadcastInfo({ src: 'material', event: 'selectedLayoutIndex', data: idx, sub: null });
          }
        } else {
          // if(this.selectedLayoutList){
          //   if(this.selectedLayoutList['markers']&&this.selectedLayoutList['markers'].length>0){
          //     let markers = this.selectedLayoutList['markers'];
          //     this.khaConfig.applyCutMarkersFromData(markers);
          //   }
          // }
          // if(this.khaConfig.current_marker.length>0){
          //   let markers = this.khaConfig.current_marker;
          //   this.khaConfig.applyCutMarkersFromData(markers);
          //   this.khaConfig.current_marker=[];
          // }

        }
      }, 1000);



    }).catch((error) => {
      // console.log("error ", error)
    });
  }
  createLayout(layout, boo = false) {
    this.configService.createLayout(layout).then(data => {
      if (data) {
        // console.log("Layout created ", data);   
        this.khaConfig.marker_history = [];
        this.getLayoutData(boo);
        // this.khaConfig.applyCutMarkersFromData(layout['markers'])
        this.broadcastInfo({ src: 'khaservice', event: 'hideloader', data: '' });
      }
    }).catch((error) => {
      this.broadcastInfo({ src: 'khaservice', event: 'hideloader', data: '' });
      console.log("error ", error);
    });
  }
  updateLayout(_id, conedata) {
    this.configService.updateLayout(_id, conedata).then(data => {
      if (data) {
        // var markerData = JSON.parse(JSON.stringify(this.khaConfig.marker_history))
        // console.log("Layout updated ", data);
        // if(this.khaConfig.current_marker.length>0)
        // this.khaConfig.current_marker.forEach(element => {
        //   this.khaConfig.deleteMarker(element)
        // });
        // this.khaConfig.marker_history=[];
        this.getLayoutData();
        // this.khaConfig.applyCutMarkersFromData(conedata['markers']);
        delete this.pickedMeshObj
        this.broadcastInfo({ src: 'khaservice', event: 'hideloader', data: '' });
      }
    }).catch((error) => {
      this.broadcastInfo({ src: 'khaservice', event: 'hideloader', data: '' });
      console.log("error ", error);
    });
  }
  deleteLayout(_id) {
    this.configService.deleteLayout(_id).then(data => {
      if (data) {
        console.log("Layout deleted ", data);
        this.getLayoutData();
      }
    }).catch((error) => {
      console.log("error ", error);
    });
  }

  layoutName = '';
  layoutHeading = "";
  isLayoutnameTyped = false;
  showLayout = false;
  LayoutMode = false;
  onLayout(e) {
    if (this.layoutName) {
      this.isLayoutnameTyped = true;
    } else {
      this.isLayoutnameTyped = false;
    }
  }
  openLayout() {
    if (this.layoutHeading) {
      this.onSaveLayout();
    } else {
      this.showLayout = true;
    }
  }
  layoutWindowClose() {
    this.showLayout = false;
    delete this.temporaryCommentData;
  }
  isActiveUndo() {
    if (this.khaConfig.layoutDragedComps.length > 0) {
      const idx = this.khaConfig.layoutDragedComps.findIndex(el => el.active === true);
      if (idx > -1) {
        return idx === 0 ? true : false;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  isActiveRedo() {
    if (this.khaConfig.layoutDragedComps.length > 0) {
      const idx = this.khaConfig.layoutDragedComps.findIndex(el => el.active === true);
      if (idx > -1) {
        return idx === this.khaConfig.layoutDragedComps.length - 1 ? true : false;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  undo() {
    let idx = this.khaConfig.layoutDragedComps.findIndex(el => el.active === true);
    if (idx > -1) {
      this.khaConfig.layoutDragedComps = this.khaConfig.clearDragCurrentState(this.khaConfig.layoutDragedComps)
      this.khaConfig.layoutDragedComps[idx - 1]['active'] = true;
      let props = this.khaConfig.layoutDragedComps[idx - 1];

      if (props['Mesh']) {
        let pos = props['Mesh']['position'];
        let x = this.khaConfig.getDifference(Number(pos['x'].toFixed(4)), Number(props['position']['x'].toFixed(4)));
        let y = this.khaConfig.getDifference(Number(pos['y'].toFixed(4)), Number(props['position']['y'].toFixed(4)));
        let z = this.khaConfig.getDifference(Number(pos['z'].toFixed(4)), Number(props['position']['z'].toFixed(4)));

        if (x === 0 && y === 0 && z === 0) {
          let idx = this.khaConfig.layoutDragedComps.findIndex(el => el.active === true);
          if (idx > 0) {
            if (idx > -1) {
              this.khaConfig.layoutDragedComps = this.khaConfig.clearDragCurrentState(this.khaConfig.layoutDragedComps)
              this.khaConfig.layoutDragedComps[idx - 1]['active'] = true;
              let props = this.khaConfig.layoutDragedComps[idx - 1];
              props['Mesh'].position.x = Number(props['position']['x'].toFixed(4));
              props['Mesh'].position.y = Number(props['position']['y'].toFixed(4));
              props['Mesh'].position.z = Number(props['position']['z'].toFixed(4));
            }
          } else {
            props['Mesh'].position.x = Number(props['position']['x'].toFixed(4));
            props['Mesh'].position.y = Number(props['position']['y'].toFixed(4));
            props['Mesh'].position.z = Number(props['position']['z'].toFixed(4));
          }
        } else {
          props['Mesh'].position.x = Number(props['position']['x'].toFixed(4));
          props['Mesh'].position.y = Number(props['position']['y'].toFixed(4));
          props['Mesh'].position.z = Number(props['position']['z'].toFixed(4));
        }
      }
    }
  }
  redo() {
    const idx = this.khaConfig.layoutDragedComps.findIndex(el => el.active === true);
    if (idx > -1) {
      this.khaConfig.layoutDragedComps = this.khaConfig.clearDragCurrentState(this.khaConfig.layoutDragedComps)
      this.khaConfig.layoutDragedComps[idx + 1]['active'] = true;
      let props = this.khaConfig.layoutDragedComps[idx + 1];

      if (props['Mesh']) {
        let pos = props['Mesh']['position'];
        let x = this.khaConfig.getDifference(Number(pos['x'].toFixed(4)), Number(props['position']['x'].toFixed(4)));
        let y = this.khaConfig.getDifference(Number(pos['y'].toFixed(4)), Number(props['position']['y'].toFixed(4)));
        let z = this.khaConfig.getDifference(Number(pos['z'].toFixed(4)), Number(props['position']['z'].toFixed(4)));

        if (x === 0 && y === 0 && z === 0) {
          const idx = this.khaConfig.layoutDragedComps.findIndex(el => el.active === true);
          if (idx < this.khaConfig.layoutDragedComps.length - 1) {
            if (idx > -1) {
              this.khaConfig.layoutDragedComps = this.khaConfig.clearDragCurrentState(this.khaConfig.layoutDragedComps)
              this.khaConfig.layoutDragedComps[idx + 1]['active'] = true;
              let props = this.khaConfig.layoutDragedComps[idx + 1];
              props['Mesh'].position.x = Number(props['position']['x'].toFixed(4));
              props['Mesh'].position.y = Number(props['position']['y'].toFixed(4));
              props['Mesh'].position.z = Number(props['position']['z'].toFixed(4));
            }
          } else {
            props['Mesh'].position.x = Number(props['position']['x'].toFixed(4));
            props['Mesh'].position.y = Number(props['position']['y'].toFixed(4));
            props['Mesh'].position.z = Number(props['position']['z'].toFixed(4));
          }
        } else {
          props['Mesh'].position.x = Number(props['position']['x'].toFixed(4));
          props['Mesh'].position.y = Number(props['position']['y'].toFixed(4));
          props['Mesh'].position.z = Number(props['position']['z'].toFixed(4));
        }
      }
    }
  }
  isActiveRestart() {
    if (this.selectedKhaSystems) {
      // console.log("this.selectedKhaSystems", this.khaConfig.selectedTagMesh)
      return false;
    } else {
      return true;
    }
  }
  resetCompoments() {
    console.log("indx1", this.khaConfig.selectedTagMesh)
    let code = this.selectedKhaSystems.code
    let key = 'HFX_' + code;
    let child = this.datauxview.getElementId(key);
    if (!child) {
      return
    }
    let mesh = this.dfx.getElementMesh(child).getChildren()[0];
    if (!mesh) {
      return
    }
    let meshes = mesh.getChildren();
    meshes.forEach((m) => {
      let mname = this.ctrlServ.getMeshName(m.name);
      if (mname == this.khaConfig.selectedTagMesh) {
        if (m) {
          m.position.x = 0;
          m.position.y = 0;
          m.position.z = 0;
          let _obj = { name: mname, position: { x: 0, y: 0, z: 0 } }
          var data = this.khaConfig.layoutComponents
          data.forEach((element, index) => {
            if (element.name == mname) {
              data.splice(index, 1);
            }
          });
        }
      }
    })
    delete this.selectedKhaSystems;
    this.khaConfig.showMatObjectTag('', '');
    this.khaConfig.isComponentDragged = true;
  }
  clearCompoments() {
    this.khaConfig.isComponentDragged = false;
    this.khaConfig.layoutComponents = [];
    this.khaConfig.layoutDragedComps = [];
    this.khaConfig.layoutPointMesh = [];
    this.khaConfig.resetDragElements();
  }
  clearMultipleComp() {
    this.khaConfig.storedMeshComps = [];
    this.khaConfig.hideHighlightSelection();
    this.khaConfig.clearCutOuts();
    // this.broadcastInfo({ src: 'material', event: 'clearLayout', data: "", sub: null });
    this.khaConfig.clearPointer();
    this.khaConfig.clearSections();
    if (this.LayoutMode) {
      this.clearLayout()
    }
    if (this.khaConfig.groupMode) {
      this.clearGroup();
    }
    this.broadcastInfo({ src: 'material', event: 'clearLayoutList', data: "" });
  }
  closeLayoutScreen() {
    this.layoutName = "";
    this.layoutHeading = "";
    this.LayoutMode = false;
    this.isLayoutnameTyped = false;
    this.khaConfig.layoutData = {};
    this.khaConfig.isComponentDragged = false;
    this.khaConfig.isDrawState = false;
    this.khaConfig.layoutComponents = [];
    this.khaConfig.layoutDragedComps = [];
    this.khaConfig.layoutPointMesh = [];
    delete this.shipCompartment;
    this.khaConfig.clearCutOuts();
    this.khaConfig.clearSections();
    this.khaConfig.resetDragElements();
    this.onChangeCameraPosition('home');
    this.broadcastInfo({ src: 'material', event: 'clearLayout', data: "", sub: null });
    delete this.selectedLayoutList;
    this.khaConfig.draw_select_mode = false;
    this.arrControlBtnProps[6].state = !this.arrControlBtnProps[6].state;
  }
  clearLayout() {
    this.khaConfig.matTagClear();
    if (this.khaConfig.isComponentDragged && !this.khaConfig.groupMode) {
      this.broadcastInfo({ src: 'material', event: 'openConformDialog', data: "", sub: null });
    } else {
      // console.log("2044","reset")
      this.closeLayoutScreen();
    }
    delete this.khaConfig.showLayoutTagData;
    delete this.khaConfig.showLayoutTagDataIdx;
  }
  layoutTagClose(e) {
    if (e == 'temp') {
      this.khaConfig.hideHighlightSelection(this.selectedMesh);
      delete this.pickedMeshObj;
      delete this.notesElement;
      delete this.notesComment;
      this.khaConfig.matTagClear();
    } else {
      if (this.layoutCloseDetailData.length == 0) {
        var selectedList = JSON.stringify(this.selectedLayoutList)
        this.layoutCloseDetailData = JSON.parse(selectedList);
        var filtered = this.layoutCloseDetailData.tagPoints.filter(function (value) {
          return value.id != e.id;
        });
        this.layoutCloseDetailData.tagPoints = filtered;
      } else {
        var filtered = this.layoutCloseDetailData.tagPoints.filter(function (value,) {
          return value.id != e.id;
        });
        this.layoutCloseDetailData.tagPoints = filtered;
      }
      // if (this.layoutCloseDetailData['tagPoints'].length > 0) {
      //   this.layoutCloseDetailData['tagPoints'].forEach(element => {
      //     element.tagShowState = false;
      //   });
      // }

      this.broadcastInfo({ src: 'material', event: 'layoutTagClose', data: e });
      this.broadcastInfo({ src: 'material', event: 'layoutTagCloseActive', data: '' });
    }

  }
  clearGroup() {
    this.khaConfig.matTagClear();
    this.khaConfig.groupMode = false;
    this.khaConfig.grouplist = [];
    delete this.shipCompartment;
    // this.onChangeCameraPosition('home');
    // this.broadcastInfo({ src: 'material', event: 'resetDeck' });
    setTimeout(() => {
      this.onChangeCameraPosition('home');
    }, 1500);
  }
  processMutipleComparment(layout = {}, boo = false) {
    this.LayoutMode = true;
    this.isLayoutnameTyped = true;
    if (Object.keys(layout).length === 0) return;
    this.layoutName = layout['layoutName'] || "";
    this.layoutHeading = layout['layoutName'] || "";
    if (layout['markers'] == undefined) {
      Object.assign(layout, { markers: [] });
    }

    if (layout['compartments'].length > 0) {
      let len = layout['compartments'].length;
      this.shipCompartment = layout['compartments'][len - 1];
    }
    this.khaConfig.clearCutOuts();
    this.khaConfig.clearSections();
    this.khaConfig.showMatObjectTag('', '');
    this.khaConfig.storedMeshComps = [];
    // this.khaConfig.hideHighlightSelection();
    this.khaConfig.layoutComponents = layout['components'] || [];
    this.khaConfig.processMutipleComparment(layout, boo);
    // this.broadcastInfo({ src: 'slmsSidepanel', event: 'notesLoading', data: true });
    // delete this.khaConfig.showLayoutTagData;
  }
  getActiveCompartment(id) {
    if (Object.keys(this.ctrlServ.shipComp).length === 0) return [];
    return this.ctrlServ.shipComp['compList'].filter(el => el.code === id);
  }
  getActiveComponent(id) {
    if (Object.keys(this.khaConfig.layoutComponents).length === 0) return [];
    return this.khaConfig.layoutComponents.filter(el => el.name === id);
  }
  getActiveCompartments() {
    if (Object.keys(this.ctrlServ.shipComp).length === 0) return [];
    return this.ctrlServ.shipComp['compList'].filter(el => el.selected === true);
  }
  onSaveLayout() {
    this.LayoutMode = true;
    let markers = this.khaConfig.getCutMarkersData() || [];
    this.broadcastInfo({ src: 'khaservice', event: 'showloader', data: "loading... " });
    let tagComments;

    if (this.notesElement) {
      delete this.notesElement['_id'];
      tagComments = this.notesElement;
    }
    // if(this.khaConfig.layoutComponents.length==0){
    //     console.log(this.khaConfig.layoutComponents);
    //     return;
    // }
    if (this.pickedMeshObj) {
      this.pickedMeshObj.hit.x.toFixed(4)
      this.pickedMeshObj.hit.z.toFixed(4)
      this.pickedMeshObj.hit.y.toFixed(4)
    }
    let obj = { layoutName: this.layoutName, compartments: [], components: this.khaConfig.layoutComponents, tagPoints: [], markers: markers };
    const idx = this.layoutData.findIndex(el => el.layoutName.split(" ").join("").toLowerCase() === this.layoutName.split(" ").join("").toLowerCase());
    // this.selectedLayoutList['tagPoints']
    if (idx > -1) {
      if (this.layoutData[idx]['markers'] == undefined) {
        Object.assign(this.layoutData[idx], { markers: [] });
      }
      if (this.layoutData[idx]['tagPoints']) {
        if (this.pickedMeshObj) {
          var pickIdx = this.layoutData[idx]['tagPoints'].findIndex(e => e.id == this.pickedMeshObj.id)
          if (pickIdx == -1) {
            this.layoutData[idx]['tagPoints'] = []
            this.layoutData[idx]['tagPoints'].push(this.pickedMeshObj)
          } else {
            var tagpoint = this.layoutData[idx]['tagPoints'][pickIdx]
            this.layoutData[idx]['tagPoints'] = []
            this.layoutData[idx]['tagPoints'].push(tagpoint)
          }
        } else {
          this.layoutData[idx]['tagPoints'] = []
        }

      }
      this.layoutData[idx]['compartments'] = obj['compartments'];
      this.layoutData[idx]['components'] = obj['components'];
      this.layoutData[idx]['tagPoints'] = this.khaConfig.updateAbsolutePosition(this.layoutData[idx]['tagPoints']);
      this.layoutData[idx]['markers'] = obj['markers'];
      if (this.layoutData[idx]['components'].length > 0 || this.layoutData[idx]['tagPoints'].length > 0 || this.layoutData[idx]['markers'].length > 0) {
        this.updateLayout(this.layoutData[idx]['_id'], this.layoutData[idx]);

      } else {
        this.broadcastInfo({ src: 'khaservice', event: 'hideloader', data: '' });
        return;
      }

    } else {
      this.khaConfig.matTagClear();
      // this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Layout name already exists !!" });
      this.layoutData.push(obj);
      if (this.temporaryCommentData) {
        this.pickedMeshObj['tagComments'] = this.temporaryCommentData;
        //this.pickedMeshObj['groupData'] = { 'name': 'Group Name', 'color': '#fff' };
        obj['tagPoints'].push(this.pickedMeshObj);

        this.khaConfig.getPartMesh(this.pickedMeshObj, (e) => {
          if (e) {
            this.khaConfig.createMatObjectPoint(this.pickedMeshObj, e);
            // this.khaConfig.updateAbsolutePosition(this.selectedLayoutList['tagPoints'])
          }
        });
        // this.khaConfig.showMatObjectTag(null, false);
        // this.khaConfig.matTagClear();
      } else {
        if (this.pickedMeshObj) {
          // if(this.pickedMeshObj['code']!='--'){
          this.pickedMeshObj['tagComments'] = tagComments;
          //this.pickedMeshObj['groupData'] = { 'name': 'Group Name', 'color': '#fff' };
          obj['tagPoints'].push(this.pickedMeshObj);
          this.khaConfig.getPartMesh(this.pickedMeshObj, (e) => {
            if (e) {
              this.khaConfig.createMatObjectPoint(this.pickedMeshObj, e);
              // this.khaConfig.updateAbsolutePosition(this.selectedLayoutList['tagPoints'])
            }
          });
          // }
        }
      }
      // this.khaConfig.showMatObjectTag(null, false);

      this.createLayout(obj, true);
    }
    // this.broadcastInfo({ src: 'material', event: 'updateLayoutData', data: this.layoutData, sub: null });
    this.layoutHeading = this.layoutName;
    this.layoutWindowClose();
    delete this.temporaryCommentData;
    this.khaConfig.isComponentDragged = false;
    this.khaConfig.isDrawState = false;
  }

  getSeletedMesh(name) {
    let key = 'HFX_' + this.selectedKhaSystems.code;
    let child = this.datauxview.getElementId(key);
    if (!child) {
      return;
    }
    let mesh = this.dfx.getElementMesh(child).getChildren()[0];
    if (!mesh) {
      return;
    }
    let meshes = mesh.getChildren();
    let filteredMesh = meshes.filter(m => this.ctrlServ.getMeshName(m.name) === name);
    if (filteredMesh.length > 0) {
      let obj = { name: name, position: { x: filteredMesh[0]['position']['x'], y: filteredMesh[0]['position']['y'], z: filteredMesh[0]['position']['z'] } };
      return obj;
    } else {
      return;
    }
  }

  selectedLayoutName;
  onSelectLayout(layout = {}) {
    if (Object.keys(layout).length === 0) return;

    let compartment = this.ctrlServ.shipComp['compList'].find(el => el.code === this.selectedKhaSystems.code);
    let components = this.getSeletedMesh(this.khaConfig.selectedTagMesh);

    if (compartment && components) {
      this.selectedLayoutName = layout['layoutName'] || "";
      const idx = this.layoutData.findIndex(el => el.layoutName.split(" ").join("").toLowerCase() === this.selectedLayoutName.split(" ").join("").toLowerCase());

      if (idx > -1) {
        const found = this.layoutData[idx]['compartments'].some(f => compartment['code'] === f.code);
        if (!found) {
          this.layoutData[idx]['compartments'].push(compartment);
        }

        const index = this.layoutData[idx]['components'].findIndex(f => components['name'] === f.name);
        if (index > -1) {
          this.layoutData[idx]['components'][index] = components;
        } else {
          this.layoutData[idx]['components'].push(components);
        }

        this.broadcastInfo({ src: 'khaservice', event: 'showloader', data: "loading... " });
        this.updateLayout(this.layoutData[idx]['_id'], this.layoutData[idx]);
        // this.khaConfig.showMatObjectTag('', '');
      }
    }
  }

  createNewLayoutTooltipState = false;
  openNewLayoutPopup() {
    this.layoutName = "";
    this.createNewLayoutTooltipState = true;
    this.showLayout = true;
  }

  handleLayoutSave() {
    if (this.createNewLayoutTooltipState) {
      this.createNewLayoutTooltipState = false;
      this.onSaveNewLayoutFromTooltip();
    } else {
      this.onSaveLayout();
    }
  }

  onSaveNewLayoutFromTooltip() {
    let compartment = this.ctrlServ.shipComp['compList'].find(el => el.code === this.selectedKhaSystems.code);
    let components = this.getSeletedMesh(this.khaConfig.selectedTagMesh);

    if (compartment && components) {
      this.selectedLayoutName = this.layoutName || "";
      const found = this.layoutData.some(el => el.layoutName.split(" ").join("").toLowerCase() === this.selectedLayoutName.split(" ").join("").toLowerCase());

      if (!found) {
        let obj = { layoutName: this.layoutName, compartments: [compartment], components: [components], tagPoints: [] };
        this.layoutData.push(obj);
        this.broadcastInfo({ src: 'khaservice', event: 'showloader', data: "loading... " });
        this.createLayout(obj);
        this.broadcastInfo({ src: 'material', event: 'updateLayoutData', data: this.layoutData, sub: null });
        this.layoutWindowClose();
      } else {
        this.selectedLayoutName = "";
        this.layoutName = "";
        this.createNewLayoutTooltipState = true;
        this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Layout name already exists !!" });
      }
    }
  }

  /**
   * Draw mode controls
   */
  removeInMarker() {
    if (this.khaConfig.draw_select_mode) {
      this.removeMarker()
    }
    if (this.khaConfig.cut_mode) {
      this.removeCut()
    }
  }
  clearInMarker() {
    if (this.khaConfig.draw_select_mode) {
      this.clearMarkers()
    }
    if (this.khaConfig.cut_mode) {
      this.clearCuts()
    }
  }
  undoInMarker() {
    if (this.khaConfig.draw_select_mode) {
      this.undoMarker()
    }
    if (this.khaConfig.cut_mode) {
      this.undoCut()
    }
  }
  removeMarker() {
    this.khaConfig.selectedMarker;
    if (this.selectedLayoutList) {
      let layoutId = this.selectedLayoutList._id
      this.selectedLayoutList['tagPoints'].forEach(element => {
        if (element.name != undefined) {
          if (element.name == this.khaConfig.selectedMarker + '_slicer') {
            // this.deleteNotes(element.tagComments)
            var selectedNotesId = element.id;
            var selectedNotesName = element.name
            this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartmentNotes', data: selectedNotesId, key: layoutId, key1: selectedNotesName });
          }
        }
      });
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'remove-marker', key: '', data: '' });
  }
  removeCut() {
    this.khaConfig.selectedMarker;
    if (this.selectedLayoutList) {
      let layoutId = this.selectedLayoutList._id
      this.selectedLayoutList['tagPoints'].forEach(element => {
        if (element.name != undefined) {
          if (element.name == this.khaConfig.selectedMarker + '_slicer') {
            // this.deleteNotes(element.tagComments)
            var selectedNotesId = element.id
            this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartmentNotes', data: selectedNotesId, key: layoutId });
          }
        }
      });
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'remove-cut', key: '', data: '' });
  }
  clearMarkers() {
    this.khaConfig.layoutData['markers'];
    this.khaConfig.layoutData['markers'].forEach(marker => {
      let layoutId = this.selectedLayoutList._id
      this.selectedLayoutList['tagPoints'].forEach(element => {
        if (element.name != undefined) {
          if (element.name == marker.uid + '_slicer') {
            // this.deleteNotes(element.tagComments)
            var selectedNotesId = element.id
            var selectedNotesName = element.name
            this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartmentNotes', data: selectedNotesId, key: layoutId, key1: selectedNotesName });
          }
        }
      });
    });
    this.broadcastInfo({ src: 'sidepanel', event: 'clear-markers', key: '', data: '' });
  }
  clearCuts() {
    this.khaConfig.layoutData['markers'];
    this.khaConfig.layoutData['markers'].forEach(marker => {
      let layoutId = this.selectedLayoutList._id
      this.selectedLayoutList['tagPoints'].forEach(element => {
        if (element.name != undefined) {
          if (element.name == marker.uid + '_slicer') {
            // this.deleteNotes(element.tagComments)
            var selectedNotesId = element.id
            var selectedNotesName = element.name
            this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartmentNotes', data: selectedNotesId, key: layoutId, key1: selectedNotesName });
          }
        }
      });
    });
    this.broadcastInfo({ src: 'sidepanel', event: 'clear-cuts', key: '', data: '' });
  }
  applyCut() {
    this.broadcastInfo({ src: 'sidepanel', event: 'apply-cut', key: '', data: '' });
  }
  undoMarker() {
    // this.khaConfig.layoutData['markers'];
    // if(this.khaConfig.layoutData['markers']&&this.khaConfig.layoutData['markers'].length>0){
    //   this.khaConfig.layoutData['markers'].forEach(marker => {
    //     let layoutId = this.selectedLayoutList._id
    //     this.selectedLayoutList['tagPoints'].forEach(element => {
    //       if (element.name != undefined) {
    //         if (element.name == marker.uid+'_slicer') {
    //           // this.deleteNotes(element.tagComments)
    //           var selectedNotesId = element.id
    //           this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartmentNotes', data: selectedNotesId, key: layoutId });
    //         }
    //       }
    //     });
    //   });
    // }
    this.broadcastInfo({ src: 'sidepanel', event: 'undo-marker', key: '', data: '' });
  }
  undoCut() {
    // this.khaConfig.layoutData['markers'];
    // this.khaConfig.layoutData['markers'].forEach(marker => {
    //   let layoutId = this.selectedLayoutList._id
    //   this.selectedLayoutList['tagPoints'].forEach(element => {
    //     if (element.name != undefined) {
    //       if (element.name == marker.uid+'_slicer') {
    //         // this.deleteNotes(element.tagComments)
    //         var selectedNotesId = element.id
    //         var selectedNotesName = element.name
    //         this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartmentNotes', data: selectedNotesId, key: layoutId, key1: selectedNotesName});
    //       }
    //     }
    //   });
    // });
    this.broadcastInfo({ src: 'sidepanel', event: 'undo-marker', key: '', data: '' });
  }
  roundOffMarker() {
    this.broadcastInfo({ src: 'sidepanel', event: 'marker-roundoff', key: '', data: '' });
  }
  //
  markerColorChange(col) {
    this.broadcastInfo({ src: 'sidepanel', event: 'apply-marker-color', key: '', data: col });
  }
  markerWidthChange(ev) {
    this.broadcastInfo({ src: 'sidepanel', event: 'apply-marker-width', key: '', data: this.markerWidth });
  }
  onDrawShapeChange(ev) {
    this.markerShape = ev.value;
    this.broadcastInfo({ src: 'sidepanel', event: 'apply-marker-shape', key: '', data: this.markerShape });
  }
  onDrawFill(ev) {
    if (ev.value == 'noFill') {
      this.fillStatus = true;
      this.broadcastInfo({ src: 'sidepanel', event: 'draw-mode-fill', key: this.fillStatus, data: '' });
    } else if (ev.value == 'fill') {
      {
        this.fillStatus = false;
        this.broadcastInfo({ src: 'sidepanel', event: 'draw-mode-fill', key: this.fillStatus, data: '' });
      }
    }
  }
  getcommpartmentCommentDetails() {
    this.configService.getData(this.configService.project_config.compartmentComment).subscribe(result => {
      this.compartmentsCommentdetatils = result;
      console.log('compartmentsComment', this.compartmentsCommentdetatils)
      this.selectedNotes()
    })
  }
  notesElement: any = {};
  notesComment: any;
  selectedNotes() {
    this.notesElement = {};
    this.notesElement['status'] = {
      value: '#b2b2b2',
      name: "status",
    }
    this.notesComment = "";
    this.compComments = '';
    if (this.compartmentsCommentdetatils && this.compartmentsCommentdetatils.length > 0 && this.selectedKhaSystems) {
      this.compartmentsCommentdetatils.forEach((element, i) => {
        if (element.compartMentCode == this.selectedKhaSystems.code && element.compartMentId == this.selectedKhaSystems.id) {

          this.notesElement = element
          if (this.notesElement) {
            this.statusUpdated = this.notesElement.status.name ? this.notesElement.status.name : '';
            // this.notesComment = element.comments
            this.compComments = element.comments;
            this.notesElement['comments'] = this.compComments;
          }

        } else {
          //delete this.notesElement;
        }
      })
    }
  }

  isActiveLayoutSave() {
    if (!this.khaConfig.isComponentDragged && !this.khaConfig.isDrawState) {
      return true;
    } else {
      return false;
    }
  }
  statusChanges(event) {
    console.log(event)
    this.statusUpdated = event
    console.log()
  }
  changeGroup(data, item = undefined) {
    delete this.khaConfig.showLayoutTagData;
    delete this.khaConfig.showLayoutTagDataIdx;
    console.log("change", data, item, this.pickedMeshObj);
    if (this.layoutHeading) {
      if (item) {
        if (item.groupData['_id']) {
          if (item.groupData['_id'] != data['_id']) {
            if (this.selectedLayoutList['tagPoints'] && this.selectedLayoutList['tagPoints'].length > 0) {
              let idx = this.selectedLayoutList['tagPoints'].findIndex(e => e.id == item['id']);
              if (idx > -1) {
                this.selectedLayoutList['tagPoints'][idx]['groupId'] = data['_id'];
                var tagPoint = this.selectedLayoutList['tagPoints'][idx];
                let layoutData = JSON.parse(JSON.stringify(this.selectedLayoutList));
                layoutData['tagPoints'] = [];
                layoutData['tagPoints'].push(tagPoint)
                this.updateLayout(layoutData['_id'], layoutData);
                this.khaConfig.updateMatObjectPoint(tagPoint, data);
              }
            }
          }
        } else {
          item['groupId'] = data['_id'];
          let layoutData = JSON.parse(JSON.stringify(this.selectedLayoutList));;
          layoutData['tagPoints'] = [];
          // tagPoint['tagComments'] = data.data;
          layoutData['tagPoints'].push(item);
          layoutData['markers'] = this.khaConfig.getCutMarkersData();
          this.updateLayout(layoutData['_id'], layoutData);

          this.khaConfig.getPartMesh(item, (e) => {
            if (e) {
              this.khaConfig.createMatObjectPoint(item, e);
              // this.khaConfig.updateAbsolutePosition(this.selectedLayoutList['tagPoints']);
            }
          });
          this.khaConfig.updateMatObjectPoint(item, data);

        }
      } else {
        this.broadcastInfo({ src: 'material', event: 'layoutTagCloseActive', data: '' });
        this.khaConfig.matTagClear();
        this.pickedMeshObj['groupId'] = data['_id'];

        this.pickedMeshObj['tagComments'] = { "status": '', "statusId": '', "startDate": new Date(), "compartMentCode": this.pickedMeshObj.code, "compartMentId": this.pickedMeshObj.partMeshId };
        let layoutData = JSON.parse(JSON.stringify(this.selectedLayoutList));;
        layoutData['tagPoints'] = [];
        // tagPoint['tagComments'] = data.data;
        layoutData['tagPoints'].push(this.pickedMeshObj);
        layoutData['markers'] = this.khaConfig.getCutMarkersData();
        this.updateLayout(layoutData['_id'], layoutData);

        this.khaConfig.getPartMesh(this.pickedMeshObj, (e) => {
          if (e) {
            this.khaConfig.createMatObjectPoint(this.pickedMeshObj, e);
            // this.khaConfig.updateAbsolutePosition(this.selectedLayoutList['tagPoints']);
          }
        });
        this.khaConfig.updateMatObjectPoint(this.pickedMeshObj, data);

      }
    } else {
      this.broadcastInfo({ src: 'material', event: 'layoutTagCloseActive', data: '' });
      // this.khaConfig.matTagClear();
      this.pickedMeshObj['groupId'] = data['_id'];
      this.pickedMeshObj['markers'] = this.khaConfig.getCutMarkersData();
      // if(this.temporaryCommentData){
      //   this.temporaryCommentData={};
      // }
      this.pickedMeshObj['tagComments'] = { "status": '', "statusId": '', "startDate": new Date(), "compartMentCode": this.pickedMeshObj.code, "compartMentId": this.pickedMeshObj.partMeshId };
      this.broadcastInfo({ src: 'material', event: 'openDialogGroupLayoutName', data: this.pickedMeshObj });
    }
    // if (this.commentDetails.length != 0) {
    //   if (this.layoutHeading) {
    //     console.log(this.selectedLayoutList)
    //     this.commentDetails[0].statusId = this.statusListData[statusIdx]._id;
    //     this.commentDetails[0].status = this.statusListData[statusIdx]
    //     // this.commentDetails[0].statusId = statusIdData;
    //     var urldata = this.configService.project_config.compartmentComment + this.commentDetails[0]._id;
    //     // this.configService.putData(urldata,this.commentDetails[0]).subscribe(result =>{
    //     //   console.log('result',result)
    //     //   this.commentDetails = result.value;
    //     // })
    //     this.temporaryCommentData = this.commentDetails[0]
    //     // this.commentDetails[0].push({ "status": this.statusListData[statusIdx], "statusId": statusIdData, "startDate": new Date(), "compartMentCode": this.selectedKhaSystems.code, "compartMentId": this.selectedKhaSystems.id })
    //     this.putComment(this.commentDetails[0])
    //     this.notesElement = this.commentDetails[0];
    //     if (this.layoutHeading) {
    //       this.updateStatusComments(this.commentDetails[0])
    //     }
    //   } else {
    //     this.commentDetails[0].status = this.statusListData[statusIdx]
    //     this.commentDetails[0].statusId = this.statusListData[statusIdx]._id;
    //     this.temporaryCommentData = this.commentDetails[0]
    //     this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutName' , data: this.temporaryCommentData});
    //   }
    // } else {
    //   this.commentDetails = [];
    //   this.commentDetails.push({ "status": this.statusListData[statusIdx], "statusId": statusIdData, "startDate": new Date(), "compartMentCode": this.selectedKhaSystems.code, "compartMentId": this.selectedKhaSystems.id })
    //   this.postComment(this.commentDetails[0])
    //   if (this.layoutHeading) {
    //     this.updateStatusComments(this.commentDetails[0])
    //   } else {
    //     this.temporaryCommentData = this.commentDetails[0]
    //     this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutName' , data: this.temporaryCommentData});
    //   }
    // }
  }

  changeStatus(data) {
    delete this.khaConfig.showLayoutTagData;
    delete this.khaConfig.showLayoutTagDataIdx;
    var statusId = this.statusListData.filter(obj => obj.name == data)
    var statusIdData = statusId[0]._id;

    var statusIdx = this.statusListData.findIndex(obj => obj.name == data)
    this.commentDetails = this.compartmentsCommentdetatils.filter(obj => {
      return obj.compartMentCode == this.selectedKhaSystems.code && obj.compartMentId == this.selectedKhaSystems.id
    })
    if (this.commentDetails.length != 0) {
      if (this.layoutHeading) {
        console.log(this.selectedLayoutList)
        this.commentDetails[0].statusId = this.statusListData[statusIdx]._id;
        this.commentDetails[0].status = this.statusListData[statusIdx]
        // this.commentDetails[0].statusId = statusIdData;
        var urldata = this.configService.project_config.compartmentComment + this.commentDetails[0]._id;
        // this.configService.putData(urldata,this.commentDetails[0]).subscribe(result =>{
        //   console.log('result',result)
        //   this.commentDetails = result.value;
        // })
        this.temporaryCommentData = this.commentDetails[0]
        // this.commentDetails[0].push({ "status": this.statusListData[statusIdx], "statusId": statusIdData, "startDate": new Date(), "compartMentCode": this.selectedKhaSystems.code, "compartMentId": this.selectedKhaSystems.id })
        this.putComment(this.commentDetails[0])
        this.notesElement = this.commentDetails[0];
        if (this.layoutHeading) {
          this.updateStatusComments(this.commentDetails[0])
        }
      } else {
        this.commentDetails[0].status = this.statusListData[statusIdx]
        this.commentDetails[0].statusId = this.statusListData[statusIdx]._id;
        this.temporaryCommentData = this.commentDetails[0]
        this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutName', data: this.temporaryCommentData });
      }
    } else {
      this.commentDetails = [];
      this.commentDetails.push({ "status": this.statusListData[statusIdx], "statusId": statusIdData, "startDate": new Date(), "compartMentCode": this.selectedKhaSystems.code, "compartMentId": this.selectedKhaSystems.id })
      this.postComment(this.commentDetails[0])
      if (this.layoutHeading) {
        this.updateStatusComments(this.commentDetails[0])
      } else {
        this.temporaryCommentData = this.commentDetails[0]
        this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutName', data: this.temporaryCommentData });
      }
    }
  }
  putComment(data) {
    var urldata = this.configService.project_config.compartmentComment + this.commentDetails[0]._id;
    this.configService.putData(urldata, data).subscribe(result => {
      console.log('result', result)
      this.commentDetails = result.value;
    })
  }
  changeStatusLayout(data, layout, tagPoint, status) {
    delete this.khaConfig.showLayoutTagData;
    delete this.khaConfig.showLayoutTagDataIdx;
    var statusId = this.statusListData.filter(obj => obj.name == status)
    var statusIdData = statusId[0]._id;
    this.statusUpdated = status;
    var statusIDX = this.statusListData.findIndex(obj => obj.name == status)
    data.status = this.statusListData[statusIDX]
    data.statusId = statusIdData;
    var updateCommentList = {
      data: data, "layOut": layout, "selectTag": tagPoint
    }
    console.log(updateCommentList)

    setTimeout(() => {
      this.updateComment(updateCommentList)
    }, 200);
    // setTimeout(() => {
    //   this.updateStatusComments(this.commentDetails[0])
    // }, 100);

  }
  updateComment(data) {
    this.khaConfig.matTagClear();
    // this.pickedMeshObj['tagComments'] = data.data;
    if (data.selectTag) {
      this.selectedLayoutList = data.layOut;
      this.selectedTagItem = data.selectTag;
    }
    if (!this.selectedLayoutList['tagPoints']) {
      this.selectedLayoutList['tagPoints'] = []
    }
    let idx = this.selectedLayoutList['tagPoints'].findIndex(e => e.id == this.selectedTagItem.id);
    if (idx > -1) {
      this.khaConfig.getPartMesh(this.selectedLayoutList['tagPoints'][idx], (e) => {
        if (e) {
          this.khaConfig.createMatObjectPoint(this.selectedLayoutList['tagPoints'][idx], e);
          // this.khaConfig.updateAbsolutePosition(this.selectedLayoutList['tagPoints'])
          // delete this.selectedTagItem;
        }
      });

      var tagPoint = this.selectedLayoutList['tagPoints'][idx];
      let layoutData = JSON.parse(JSON.stringify(this.selectedLayoutList));
      layoutData['tagPoints'] = [];
      tagPoint['tagComments'] = data.data;
      layoutData['tagPoints'].push(tagPoint)
      // this.selectedLayoutList['tagPoints'][idx]['tagComments'] = data.data;
      layoutData['markers'] = this.khaConfig.getCutMarkersData() || [];
      this.updateLayout(layoutData['_id'], layoutData);
    }
  }
  tagStatusUpdate: any;
  uasdasStatus(item) {
    console.log("update", item)
    this.tagStatusUpdate = item.code;
  }
  postComment(postData) {
    this.configService.postData(this.configService.project_config.compartmentComment, postData).subscribe(result => {
      console.log('result', result)
      this.getcommpartmentCommentDetails();
    })
  }

  componentLoad() {
    console.log(this.selectedKhaSystems)
    const filterData = this.ctrlServ.shipComp['compList'].filter(el => el.code === this.mname)
    console.log(filterData)
    this.compartmentLoad = filterData[0];
  }
  compartmentLoads() {
    this.layoutTagClose('temp');
    this.broadcastInfo({ src: 'slmsSidepanel', event: 'compartmentLoad', data: this.compartmentLoad });
  }
  clearLoadCompartment() {
    this.layoutTagClose('temp');
    this.broadcastInfo({ src: 'slmsSidepanel', event: 'clearLoadCompartment', data: this.compartmentLoad });
  }
  groupColorUpdated(data) {
    if (this.selectedMesh) {
      this.khaConfig.highlightSelection(this.selectedMesh, 4, data.color, true, this.highlightCompState);
    }
  }
  deleteNotes(data) {
    var notesData = data.tagComments
    var shipCompartmentDetails = this.compartmentsCommentdetatils.filter(obj => {
      return obj.compartMentCode == notesData.compartMentCode && obj.compartMentId == notesData.compartMentId
    })
    console.log(shipCompartmentDetails)
    if (shipCompartmentDetails.length != 0) {
      this.configService.deleteComment(shipCompartmentDetails[0]._id).then(data => {
      }).catch((error) => {
        console.log("error ", error);
      });
    }
  }
  /**
 * load pdf Viewer
 */
  loadPdfViewer() {
    var item = this.pageNo[Math.floor(Math.random() * this.pageNo.length)];
    console.log(item)
    this.showOverlayPdfViewer = true
    this.pdfPageNo = Number(item);

    //this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: "", event: 'showBlockLoading' } });
    // this.loadPdf.emit(pageNo);
  }

  /* * *
* pdf viewer panel close
* * */
  pdfViewerClose() {
    this.showOverlayPdfViewer = false;
  }
  statusPopWindowClose() {
    this.statusWindow = false;
    // delete this.editGroupData;
    // delete this.groupName, this.groupState, this.groupData;
  }

  /* * *
* Status code start
* * */
  getStatusData() {
    this.configService.getStatusData().then((response: any) => {
      console.log("getStatusData ", response);
      this.statusListData = response;
      this.khaConfig.tagStatus = this.statusListData;
      this.broadcastInfo({ src: 'kys', event: 'updateStatus', data: this.statusListData });
      if (this.statusTag) {
        this.changeStatus(this.statusNames);
      }
      this.statusTag = false;
      setTimeout(() => {
        this.statusUpdateDetails();
      });
    }).catch((error) => {
      console.log("error ", error);
    });
  }
  statusNames: any;
  onSaveStatus() {
    var data = { "name": "", "value": "" };
    data['name'] = this.statusName;
    data['value'] = this.statusColor;
    if (this.statusId) {
      this.configService.updateStatus(this.statusId, data).then(data => {
        if (data) {
          console.log("Status updated ", data);
          this.statusWindow = false;
          delete this.statusName;
          delete this.groupState
          delete this.statusColor;
          delete this.statusId;
          this.getStatusData()
          this.broadcastInfo({ src: 'kys', event: 'updateStatusData', data: "reConstructTagJson" });
        }
      }).catch((error) => {
        console.log("error ", error);
      });
    } else {
      const found = this.statusListData.some(el => el.name.split(" ").join("").toLowerCase() === this.statusName.split(" ").join("").toLowerCase());
      if (!found) {
        this.configService.createStatus(data).then(data => {
          if (data) {
            console.log("Status created ", data);
            this.statusWindow = false;
            this.statusNames = this.statusName;
            delete this.statusName;
            delete this.groupState
            delete this.statusColor;
            this.getStatusData()
            console.log(this.statusName, this.statusColor);
            this.broadcastInfo({ src: 'kys', event: 'updateStatusData', data: "reConstructTagJson" });

          }
        }).catch((error) => {
          console.log("error ", error);
        });
      } else {
        this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Status name already exists !!" });
        this.statusWindow = true;
      }
    }
  }
  deleteStatusData(_id) {
    this.configService.deleteStatus(_id).then(data => {
      if (data) {
        console.log("Status deleted ", data);
        this.getStatusData()
        this.broadcastInfo({ src: 'kys', event: 'updateStatusData', data: "reConstructTagJson" });
      }
    }).catch((error) => {
      console.log("error ", error);
    });
  }
  statusTag: any = false;
  openStatusPanel() {
    this.btnStatus = 'Create';
    this.statusHeading = 'Create Status';
    this.statusTag = true;
    this.statusWindow = true;
  }
  statusUpdate(statusId) {
    var data = { "name": "", "value": "" };
    data['name'] = this.statusName;
    data['value'] = this.statusColor;
    this.configService.updateStatus(statusId, data).then(data => {
      if (data) {
        console.log("Status updated ", data);
        this.statusWindow = false;
        delete this.statusName;
        delete this.groupState
        delete this.statusColor;
        this.getStatusData()
        this.broadcastInfo({ src: 'kys', event: 'updateStatusData', data: "reConstructTagJson" });
      }
    }).catch((error) => {
      console.log("error ", error);
    });
  }
  statusUpdateDetails() {
    var layout = this.selectedLayoutList;
    if (layout) {
      var layoutData = layout['tagPoints']
      layoutData.forEach(tagcom => {
        var tag = tagcom.tagComments
        if (tag && tag.statusId) {
          let filteredStatus = this.statusListData.filter(m => m._id == tag.statusId);
          var statusData = filteredStatus[0]
          if (statusData != undefined) {
            tag.status.name = statusData.name;
            tag.status.value = statusData.value;
          } else {
            tag.status.name = '';
            tag.status.value = '';
          }
          if (statusData == undefined) {
            tag.status.name = '';
            tag.status.value = '';
          }
        }
      });
    }
  }
  updateStatusComments(data) {
    this.khaConfig.matTagClear();
    if (this.pickedMeshObj) {
      this.pickedMeshObj.hit.x.toFixed(4)
      this.pickedMeshObj.hit.z.toFixed(4)
      this.pickedMeshObj.hit.y.toFixed(4)
    }
    this.pickedMeshObj['tagComments'] = data;
    if (!this.selectedLayoutList['tagPoints']) {
      this.selectedLayoutList['tagPoints'] = []
    }
    this.selectedLayoutList['compartments'] = this.getActiveCompartments();
    this.selectedLayoutList['components'] = this.khaConfig.layoutComponents;
    if (this.selectedGropProps) {
      // this.pickedMeshObj['groupData'] = { name: this.selectedGropProps['name'], color: this.selectedGropProps['color'] }
    } else {
      //this.pickedMeshObj['groupData'] = { name: 'Group Name', color: '#fff' }
    }
    //this.pickedMeshObj['markers'] = 

    let mname = this.khaConfig.getMeshName(this.pickedMeshObj['partMeshId']);
    const found = this.khaConfig.storedMeshComps.some(el => el === mname);
    if (!found) {
      this.khaConfig.storedMeshComps.push(mname);
    }
    let layoutData = JSON.parse(JSON.stringify(this.selectedLayoutList));
    if (layoutData['tagPoints']) {
      var pickIdx = layoutData['tagPoints'].findIndex(e => e.id == this.pickedMeshObj.id)
      if (pickIdx == -1) {
        layoutData['tagPoints'] = [];
        layoutData['tagPoints'].push(this.pickedMeshObj);
      } else {
        var tagpoint = layoutData['tagPoints'][pickIdx]
        layoutData['tagPoints'] = [];
        layoutData['tagPoints'].push(tagpoint)
      }
    }
    layoutData['markers'] = this.khaConfig.getCutMarkersData() || [];
    this.selectedTagItem = this.pickedMeshObj;
    this.updateLayout(layoutData['_id'], layoutData);
    this.khaConfig.getPartMesh(this.pickedMeshObj, (e) => {
      if (e) {
        this.khaConfig.createMatObjectPoint(this.pickedMeshObj, e);
      }
    });
  }
}
